import React, { Component, createContext } from 'react';
import logo from './logo.svg';
import FakeData from './fake-data';
//import io from 'socket.io-client';
import './App.css';
import './css/styles.css';
import './css/training.css';
import createBrowserHistory from 'history/createBrowserHistory';

import HeaderUI, { HeaderShimmer } from './components/HeaderUI';
import FooterUI from './components/FooterUI';
import Geosuggest from 'react-geosuggest';
import { IntroOverlayTarget, ChatBoxList, Modal, EmptyState, LoadingState, BannerShimmer, InputField, FeedBackPopUp } from './components/Common';
import DatePicker from './components/DatePicker'
import FireBase from 'firebase';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import { View, AsyncStorage, TouchableOpacity, ScrollView, Image, Text, ActivityIndicator } from 'react-native'
import Ionicon from 'react-ionicons';
//PAGES
import { GMCView, GMCCore } from './pages/GMC';
import League from './pages/LEAGUE';
import Team from './pages/TEAM';
import Profile from './pages/Profile';
import Admin from './pages/Admin';
import Chat from './pages/Chat';
import HomePage from './pages/HomePage';
import Game from './pages/GAME';
import Search from './pages/Search';
import Create from './pages/CREATE';
import TournamentInit from './pages/CreatePages/TournamentInit';
import ClubInt from './pages/CreatePages/ClubInit';
import EducationInit from './pages/CreatePages/EducationInit';
import TeamInit from './pages/CreatePages/TeamInit';
import TestView from './pages/Test';
import PostView from './pages/PostView';
import Club from './pages/Club';
import Institution from './pages/Institution';
import Group from './pages/Group';
import TacticBoard from './pages/TacticBoard';
import Home from './pages/Home';
import Event from './pages/Event';
import Events from './pages/Events';
import VideoStreamTV from './components/VideoStreamTV';

import { BrowserRouter, HashRouter, Route, Link, withRouter, Switch, Redirect, Prompt } from 'react-router-dom';
import Sports from './pages/Sports';
import Dashboard from './pages/Dashboard';
import Support from './pages/Support';

import en from 'react-intl/locale-data/en.js';
import fr from 'react-intl/locale-data/fr.js';
import { IntlProvider, addLocaleData } from 'react-intl';
import GoogleAnalytics from './GoogleAnalytics';
import SHA1 from './components/SHA1';
import 'eventsource-polyfill';
import io from 'socket.io-client';
//import { Router } from 'react-static'
/*import axios from 'axios';

axios.defaults.baseURL = FakeData.URL;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.post['Accept'] = 'application/json';*/
window.io = io;
const $ = window.$;
const jQuery = window.jQuery;

const _pageName = "/lemon-100";
const _homeName = "/app"
console.log('context',React.createContext)
addLocaleData([...en, ...fr])

const { port, hash, hostname, host, href, protocol } = window.location;
const { EventSource } = window;

//console.log(process.env);

const fakeAuth = FakeData.auth0;

function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	var expires = "expires=" + d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
	var name = cname + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

const getUserID = () => {
	const user = getCookie("supotsu-user").split("-");
	return user[1];
}

class App extends Component {
	constructor(props) {
		super(props)
		this.state = {
			user: FakeData.you(),
			openChats: []
		}

		this.onNavChanged = this.onNavChanged.bind(this);
	}

	componentWillMount() {
		const _that = this;

		FakeData.shared("mainThread", this)
		if (getCookie("supotsu-user") === "") {
			this.system = null;
			this.setState({
				isLogged: false
			});
			this.initSystem();
		} else {
			const user = getCookie("supotsu-user").split("-");
			//this.system = new EventSource(FakeData.URL + '/testServer.php?auth0&user=' + user[1]);
			this.setState({
				isLogged: true,
				userId: user[1]
			});
			//this.initSystem(user[1]);
		}

		var config = {
			apiKey: "AIzaSyBlBYrHXQ3NkjxNgrot7CSZ0BHU5DuCdl0",
			authDomain: "supotsu-4e027.firebaseapp.com",
			databaseURL: "https://supotsu-4e027.firebaseio.com",
			projectId: "supotsu-4e027",
			storageBucket: "supotsu-4e027.appspot.com",
			messagingSenderId: "964973417522"
		};
		if (!FireBase.apps.length) {
			//FireBase.initializeApp(config);
		}
		//this.messaging = FireBase.messaging();
	}

	initSystem = (username = null) => {
		if (username === null) {
			return;
		}
	}

	componentDidMount() {
		if (this.state.isLogged) {
			this.getData()
			this.setOnline()
			this.getMessageNotice()
			this.getEventNotice()
			this.getTeams()
			this.getSports()
			this.getGeoData()

			const _that = this;

			const grantedCB = () => {
				this.messaging.getToken().then(function (currentToken) {
					if (currentToken) {
						console.log(currentToken)
					} else {
						// Show permission request.
						console.log('No Instance ID token available. Request permission to generate one.');
						// Show permission UI.
						_that.updatePermision(grantedCB);
					}
				}).catch(function (err) {
					console.log('An error occurred while retrieving token. ', err);
				});
			}
			//this.socket = io(hostname);
			/*this.messaging.requestPermission().then(function() {
				console.log('Notification permission granted.');
				grantedCB();
			  }).catch(function(err) {
				console.log('Unable to get permission to notify.', err);
			  });*/
		} else {
			this.getTeams()
			this.getSports()
		}

		window.addEventListener("hashchange", this.onNavChanged)
		document.querySelector('#root').scrollIntoView({
			behavior: 'smooth'
		});
	}

	updatePermision = (cb=()=>{}) => {
		if(this.messaging){
			this.messaging.requestPermission().then(function() {
				console.log('Notification permission granted.');
				cb();
			}).catch(function(err) {
				console.log('Unable to get permission to notify.', err);
			});
		}
	}

	componentWillUnmount() {
		window.removeEventListener("hashchange", this.onNavChanged)
		this.initSystem();
	}

	onNavChanged(e) {
		document.getElementById("root").scrollTop = 0;
	}

	getGeoData = () => {
		const _that = this;
		//https://freegeoip.net/json/
		/* FakeData.post('https://freegeoip.net/json/', {}, {
		   success: ((res) => {
			 FakeData.setData("geo-data", res);
			 //console.log(res);
			 setTimeout(() => {
			   _that.getGeoData()
			 }, 1000)
		   }),
		   error: ((err) => {
	 
		   })
		 })*/
	}

	getData() {
		const _that = this
		let userId = getUserID()

		FakeData.post('/getUserProfile.php?auth0&id=' + userId + '&them=' + userId, {}, {
			success: ((res) => {
				FakeData.setData("yoo", res);
				//console.log(res);
				_that.setLeagueIds(res.leagues)
				_that.setTeamsFollowed(res.teamsFollowed, res.myTeams, res.ownTeams)
				_that.setClubIds(res.clubs)
				_that.setInstitutionsIds(res.institutions)
				_that.setFriendsIds(res.friends);
				setTimeout(() => {
					//_that.getData()
				}, 1000)
			}),
			error: ((err) => {

			})
		})
	}

	getTeams() {
		const _that = this
		FakeData.post("/getAllTeams.php?auth0", {}, {
			success: ((res) => {

				FakeData.setData("all_teams", res);
			}),
			error: ((err) => {

			})
		})

		setTimeout(() => {
			//_that.getTeams()
		}, 1000)
	}

	getSports() {
		const _that = this
		FakeData.post("/getAllSports.php?auth0", {}, {
			success: ((res) => {

				FakeData.setData("all_sports", res);
				setTimeout(() => {
					//_that.getSports()
				}, 1000)
			}),
			error: ((err) => {

			})
		})
	}

	setInstitutionsIds(arr) {
		const list = []
		for (let i = 0; i < arr.length; i++) {
			list.push(arr[i].id)
		}

		FakeData.setData("instIds", list);
	}

	setFriendsIds(arr) {
		const list = []
		for (let i = 0; i < arr.length; i++) {
			list.push(arr[i].id)
		}

		FakeData.setData("friendIds", list);
	}

	setLeagueIds(arr) {
		const list = []
		for (let i = 0; i < arr.length; i++) {
			list.push(arr[i].id)
		}

		FakeData.setData("leagueIds", list);
	}

	setClubIds(arr) {
		const list = []
		for (let i = 0; i < arr.length; i++) {
			list.push(arr[i].id)
		}

		FakeData.setData("clubIds", list);
	}

	setOnline() {
		const _that = this
		let id = (typeof FakeData.getData("yoo") === "object") ? FakeData.getData("yoo").id : getUserID();
		if (id === null || id === "") {
			setTimeout(() => {
				_that.setOnline()
			}, 5000)
		}

		FakeData.post("/setOnline.php?auth0", { userId: id }, {
			success: ((res) => {
				setTimeout((() => {
					_that.setOnline()
				}), 50000)
			}),
			error: ((err) => {

			})
		})
	}

	getMessageNotice() {
		const _that = this
		if (!FakeData.getData("yoo") || typeof FakeData.getData("yoo") !== "object") {
			setTimeout(() => {
				_that.getMessageNotice()
			}, 10000)
			return
		}
		const dataTo = {
			user: FakeData.getData("yoo")
		}

		FakeData.post("/getMessageNotice.php?auth0", dataTo, {
			success: ((res) => {
				FakeData.setData("unreadMgs", res)
				setTimeout(() => {
					_that.getMessageNotice()
				}, 10000)
			}),
			error: ((err) => {

			})
		})
	}

	getEventNotice() {
		const _that = this
		if (!FakeData.getData("yoo") || typeof FakeData.getData("yoo") !== "object") {
			setTimeout(() => {
				_that.getEventNotice()
			}, 10000)
			return
		}
		const dataTo = {
			user: FakeData.getData("yoo")
		}

		FakeData.post("/getEventNotice.php?auth0", dataTo, {
			success: ((res) => {
				FakeData.setData("unreadEvt", res)
				setTimeout(() => {
					_that.getEventNotice()
				}, 10000)
			}),
			error: ((err) => {

			})
		})
	}

	setTeamsFollowed(arr, arr2, arr3) {
		const list = []
		for (let i = 0; i < arr.length; i++) {
			if (arr[i].id === 0) {
				continue;
			}
			list.push(arr[i].id)
		}

		for (let i = 0; i < arr2.length; i++) {
			if (arr2[i].id === 0) {
				continue;
			}
			if (list.indexOf(arr2[i].id) > -1) {
				continue;
			}

			list.push(arr2[i].id)
		}

		for (let i = 0; i < arr3.length; i++) {
			if (arr3[i].id === 0) {
				continue;
			}
			if (list.indexOf(arr3[i].id) > -1) {
				continue;
			}

			list.push(arr3[i].id)
		}

		FakeData.setData("teamIds", list);
	}

	addToChats(chat) {
		//console.log(chat)
		const str = "chat" + chat.id + "you";
		let bool = false;
		FakeData.chats.forEach((item, i) => {
			if (item.chatBoxRef === str) {
				bool = true
			}
		})

		if (bool) {
			return;
		}
		chat.chatBoxRef = str
		FakeData.chats.push(chat)
		FakeData.shared("chatWidget").getData()
	}

	removeChat(str) {
		FakeData.chats.forEach((item, i) => {
			if (item.chatBoxRef === str) {
				FakeData.chats.splice(i, 1)
				FakeData.shared("chatWidget").getData()
			}
		})
	}

	onLogin(username, isAdmin, url = false) {
		const _that = this;
		if (isAdmin && username === null) {
			window.location = _homeName;
			FakeData.setAdmin(true);
			return;
		} else if (isAdmin && username !== null) {
			window.location = _homeName;
			FakeData.setGuest(true);
			return;
		}



		_that.setState({
			userId: username
		});

		_that.getData()
		_that.setOnline()
		_that.getMessageNotice()
		_that.getEventNotice()

		this.initSystem(username);
		window.location = url?url:"/profile/" + username;
	}

	onRegister(username) {
		const _that = this;
		_that.setState({
			userId: username
		});

		_that.getData()
		_that.setOnline()
		_that.getMessageNotice()
		_that.getEventNotice()
		this.initSystem(username);

		window.location = "/profile/" + username;
	}

	render() {
		const currentKey = this.props.location.pathname.split('/')[1] || '/';
		const timeout = { enter: 300, exit: 200 }
		const {user} = this.state;
		return (
			<View style={{
				flex: 1
			}}>
				<TransitionGroup component="div">
					<CSSTransition key={currentKey} timeout={timeout} classNames="fade" appear>
						<Switch>
							<Route exact path="/" component={_Home}></Route>
							<Route exact path={_homeName} component={(props) => <EncryptedPages pageType="H" component={Home} {...props} />}></Route>
							<Route exact path="/u/:id" component={(props) => <EncryptedPages pageType="F" component={Profile} {...props} />} />
							<Route exact path="/login" component={(props) => <Login onLogin={this.onLogin.bind(this)} {...props} />} />
							<Route exact path="/login/:token/:user_id" component={ConfirmLogin} />
							<Route exact path="/change_password/:token" component={ChangeLogin} />
							<Route exact path="/admin" component={(props) => <EncryptedPages pageType="DASH" component={Admin} {...props} />} />
							<Route exact path="/register" component={(props) => <Register onRegister={this.onRegister.bind(this)} {...props} />} />
							<Route exact path="/game/:id" component={(props) => <EncryptedPages pageType="G" component={Game} {...props} />} />
							<Route exact path="/create" component={(props) => <EncryptedPages withGuest={true} pageType="create" component={Create} {...props} />}></Route>
							<Route exact path="/create/tournament" component={(props) => <EncryptedPages pageType="create" component={TournamentInit} {...props} />}></Route>
							<Route exact path="/create/club" component={(props) => <EncryptedPages pageType="create" component={ClubInt} {...props} />}></Route>
							<Route exact path="/create/institution" component={(props) => <EncryptedPages pageType="create" component={EducationInit} {...props} />}></Route>
							<Route exact path="/create/team" component={(props) => <EncryptedPages pageType="create" component={TeamInit} {...props} />}></Route>
							<Route exact path="/profile/:id" component={(props) => <EncryptedPages pageType="F" component={Profile} {...props} />} />
							<Route exact path="/gmc" component={(props) => <EncryptedPages pageType="GMC" component={GMCView} {...props} />} />
							<Route exact path="/core/:gameId" component={(props) => <EncryptedPages pageType="GMCC" component={GMCCore} {...props} />} />
							<Route exact path="/console/:gameId" component={(props) => <EncryptedPages pageType="GMCC" component={GMCCore} {...props} />} />
							<Route exact path="/club/:id" component={(props) => <EncryptedPages withGuest={true} pageType="C" component={Club} {...props} />} />
							<Route exact path="/institution/:id" component={(props) => <EncryptedPages withGuest={true} pageType="I" component={Institution} {...props} />} />
							<Route exact path="/chats" component={(props) => <EncryptedPages pageType="MSG" component={Chat} {...props} />} />
							<Route exact path="/events" component={(props) => <EncryptedPages pageType="EV" component={Events} {...props} />} />
							<Route exact path="/search" component={(props) => <EncryptedPages pageType="SCH" component={Search} {...props} />} />
							<Route exact path="/event/:id" component={(props) => <EncryptedPages pageType="E" component={Event} {...props} />} />
							<Route exact path="/videos" component={(props) => <EncryptedPages hideExtra={true} pageType="Videos" component={Videos} {...props} />} />
							<Route exact path="/test" component={TestView} />
							<Route exact path="/game-video/:id" component={(props) => <EncryptedPages hideExtra={true} pageType="Video" component={Video} {...props} />} />
							<Route exact path="/post/:userName/posts/:id/:type" component={(props) => <EncryptedPages pageType="FEED" component={PostView} {...props} />} />
							<Route exact path="/team/:id" component={(props) => <EncryptedPages withGuest={true} pageType="T" component={Team} {...props} />} />
							<Route exact path="/league/:id" component={(props) => <EncryptedPages withGuest={true} pageType="L" component={League} {...props} />} />
							<Route exact path="/tournament/:id" component={(props) => <EncryptedPages withGuest={true} pageType="L" component={League} {...props} />} />
							<Route exact path="/group/:id" component={(props) => <EncryptedPages pageType="Q" component={Group} {...props} />} />
							<Route exact path="/tactic-board/:sport" component={(props) => <EncryptedPages pageType="TACTIC" component={TacticBoard} {...props} />} />
							<Route exact path="/all-sports" component={(props) => <EncryptedPages pageType="TACTIC" component={Sports} {...props} />} />
							<Route exact path="/dashboard/:id" component={(props) => <EncryptedPages pageType="DASH" component={Dashboard} {...props} />} />
							<Route exact path="/support" component={(props) => <EncryptedPages pageType="DASH" component={Support} {...props} />} />
							<Route exact path="/confirm/:hash/:id" component={ConfirmAcivity} />
							<Route exact path={_pageName} component={HomePage} />
							<Route exact path="/404" component={NoMatch} />
							<Route exact component={NoMatch} />
						</Switch>
					</CSSTransition>
				</TransitionGroup>
				<GoogleAnalytics />
				<IsBlockedAccountContainer />
			</View>
		);
	}
}
const _Home = () => {
	return(
		<Scaffold hideExtra={true}>
			<View style={{
				flex: 1,
				position: 'fixed',
				top: 0,
				left: 0,
				bottom: 0,
				right: 0,
				backgroundColor: '#345'
			}}>
				<Image source={require('./images/supotsu_logo.svg')} style={{
					width: '100%',
					height: '100%',
					resizeMode:'contain'
				}}/>
			</View>
		</Scaffold>
	)
}

class IsBlockedAccountContainer extends Component {
	constructor(props) {
		super(props);

		this.state = {
			user : {isGuest: true}
		}
	}

	componentDidMount() {
		const _that = this;
		this._isMounted = false
		this.timer = setInterval(()=>{
			if(_that._isMounted) _that.setState({user:FakeData.you()})
		}, 10000);
	}

	componentWillUnmount() {
		this._isMounted = false
		clearInterval(this.timer)
	}	

	render(){
		const { isGuest } = this.state.user;
		if (isGuest) {
			return null;
		}

		return <IsBlockedAccount />;
	}
}

class _IsBlockedAccount extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isBlocked: false,
			data: true,
			isServerDown: false,
			isDashboard: false
		}
	}

	componentDidMount() {
		this._isMounted = true;
		this.getBlockState();
	}

	componentWillUnmount() {
		this._isMounted = false
	}

	isDashboard = () => {
		const _bool = FakeData.getData("isDashboard") ? true : false;
		return _bool;
	}

	getBlockState = () => {
		const _that = this;

		const dataTo = {
			userId: FakeData.getData("yoo").id,
			userType: "F"
		}

		FakeData.post(FakeData.apiURL+"/admin/block/get", dataTo, {
			headers: {
				'Content-Type': 'application/json'
			},
			method: "POST",
			success(res) {
				const { isBlocked, data } = res;

				if (FakeData.shared("Scaffold")) {
					FakeData.shared("Scaffold").setBlocked(isBlocked, () => {
						_that.setState({
							isBlocked,
							data,
							isServerDown: false,
							isDashboard: _that.isDashboard()
						})
					});
				}

				if (_that._isMounted) {
					setTimeout(() => {
						_that.getBlockState();
					}, 1500);
				}
			},
			error(error) {
				if (FakeData.shared("Scaffold")) {
					FakeData.shared("Scaffold").setBlocked(true, () => {
						_that.setState({
							isBlocked: true,
							isServerDown: true,
							isDashboard: _that.isDashboard()
						})
					});
				}

				if (_that._isMounted) {
					setTimeout(() => {
						_that.getBlockState();
					}, 1500);
				}
			}
		});
	}

	render() {
		const { isBlocked, isServerDown, isDashboard } = this.state;
		if (!isBlocked || isDashboard) {
			return null;
		}

		return (
			<div style={{
				position: "fixed",
				top: 0,
				left: 0,
				zIndex: 10000,
				right: 0,
				bottom: 0,
				background: "rgba(0,0,0,0.4)"
			}}>

				<div style={{
					marginTop: "30vh",
					background: "#fff",
					height: "calc(100% - 30vh)"
				}}>
					<EmptyState onClick={()=>{
						window.location = '/support'
					}} isShown={true} actionLabel={"OPEN SUPPORT INBOX"} text={isServerDown ? "SYSTEM DOWN" : "Your account has been blocked"} icon="person" />
				</div>
			</div>
		)
	}
}

const IsBlockedAccount = withRouter(_IsBlockedAccount);

class Video extends Component {
	constructor(props) {
		super(props)
		this.state = {
			game: null
		}
	}

	componentDidMount() {
		this._isMounted = true;
		this.checkGame()

		window.onbeforeunload = function (event) {
			if (FakeData.io) {
				FakeData.io.emit("close-game-live", this.props.match.params.id)
			}
			return false;
		};
	}

	componentWillUnmount() {
		this._isMounted = false;
		FakeData.setData("currentGameScreen", false);
		this.removeGame()
	}

	getGame() {
		const _that = this
		const User = FakeData.getData("yoo")
		const dataTo = {
			userId: User.id,
			gameId: this.props.match.params.id
		}

		FakeData.post('/getPublicGame.php?auth0', dataTo, {
			success: ((res) => {
				if (!_that._isMounted) {
					return
				}
				const data = res
				_that.setState({
					game: data.core
				})
			}),
			error: ((err) => {

			})
		})
	}

	checkGame = () => {
		const _that = this;
		const _data = {
			id: this.props.match.params.id
		}

		FakeData.post('https://supotsu.com:8080/get-live-game', _data, {
			success: ((res) => {
				if (!_that._isMounted) {
					return
				}
				if (res.error) {
					window.close();
				} else {
					_that.setState({
						game: res.msg
					})
				}
			}),
			error: ((err) => {

			})
		})
	}

	removeGame = () => {
		const _that = this;
		const _data = {
			id: this.props.match.params.id
		}

		FakeData.post('https://supotsu.com:8080/remove-live-game', _data, {
			success: ((res) => {
				if (!_that._isMounted) {
					return
				}
				if (!res.error) {
					setTimeout(() => {
						if (window) {
							window.close();
						}
					}, 1500)
				}
			}),
			error: ((err) => {

			})
		})
	}

	render() {
		const { game } = this.state;
		if (game === null) {
			return (
				<BannerShimmer />
			);
		}
		const user = {
			type: "G",
			...game
		}
		return (
			<VideoStreamTV user={user} isLive={true} isGame={true} onClose={() => {
				this.removeGame();
			}} />
		)
	}
}

class Videos extends React.PureComponent {
	render() {
		return (
			<VideoStreamTV isLive={false} />
		)
	}
}

const NoMatch = ({ location }) => (
	<Scaffold hideExtra={!true}>
		<div style={{ width: "60vw", height: "45vh", background: "#fff" }} className={"confirm-pf-box"}>
			<img src={"images/404.png"} style={{ width: "auto", height: "10vw", borderRadius: "0px" }} />
			{/*<span>{"404"}</span>*/}
			<div className={"desc"}>{"Requested page not found, please check the url then try again!"}</div>
			<button onClick={() => {
				window.location = _homeName;
			}}>Go Home</button>
		</div>
	</Scaffold>
)

class ConfirmAcivity extends Component {
	constructor(p) {
		super(p)
		this.state = {
			isLoading: true,
			isVerifying: false,
			isDone: false,
			error: false,
			obj: null
		};
	}

	componentDidMount() {
		this._isMounted = true;
		this.getData()
	}

	getData = () => {
		const _that = this;
		const data = {
			hash: this.props.match.params.hash,
			id: this.props.match.params.id
		}

		let url = "";
		if (FakeData.inArray(this.props.match.params.hash, ["T", "F", "C", "L", "I", "Q"])) {
			url = "/getConfirm.php?auth0&by_id";
		} else {
			url = "/getConfirm.php?auth0";
		}

		FakeData.post(url, data, {
			success(res) {
				if (!_that._isMounted) {

					return;
				}

				if (res.error) {
					_that.setState({ error: true, obj: null, isLoading: false });
				} else {
					_that.setState({ obj: res, error: false, isLoading: false });
				}
			},
			error() {
				_that.setState({ error: true, obj: null, isLoading: false });
			}
		})
	}

	verify = () => {
		const { isLoading, isVerifying, error, obj, isDone } = this.state;
		const _that = this;
		const data = {
			id: obj.id
		}

		FakeData.post("/verifyProfile.php?auth0", data, {
			success(res) {
				_that.setState({
					isVerifying: false,
					isDone: true
				});
			},
			error(e) {
				_that.setState({
					isVerifying: false,
					isDone: false
				});
			}
		})
	}

	getPath = (user, search = "?sInit=about") => {
		let path = { pathname: "/", search };
		switch (user.type) {
			case "F":
				path.pathname = "/profile/" + user.user;
				break;
			case "P":
				path.pathname = "/profile/" + user.user;
				break;
			case "T":
				path.pathname = "/team/" + user.id;
				break;
			case "C":
				path.pathname = "/club/" + user.user;
				break;
			case "I":
				path.pathname = "/institution/" + user.user;
				break;
			case "L":
				path.pathname = "/tournament/" + user.user;
				break;
			default:
				path.pathname = "/";
				path.search = "";
				break;
		}

		return path;
	}

	render() {
		const { isLoading, isVerifying, error, obj, isDone } = this.state;
		if (isLoading) {
			return (
				<Scaffold hideExtra={true}>
					<div style={{ width: "60vw", height: "45vh", background: "#fff" }}>
						<LoadingState style={{ width: "100%", height: "100%", background: "#fff" }} isShown={true} text={"Please wait while validating confirmation token"} />
					</div>
				</Scaffold>
			)
		}

		if (error || obj === null) {
			return (
				<Redirect to={{
					pathname: "/404",
					state: { from: this.props.location }
				}} />
			)
		}

		return (
			<Scaffold hideExtra={true}>
				<div style={{ width: "60vw", height: "45vh", background: "#fff" }} className={"confirm-pf-box"}>
					<img src={obj.user.image} />
					<span>{obj.user.name}</span>
					{!obj.verified && <div className={"desc"}>{"Confirm this profile?"}</div>}
					{obj.verified && <div className={"desc"}>{"Profile already verified!"}</div>}
					{!obj.verified &&
						<button onClick={() => {
							this.setState({ isVerifying: true });
							this.verify();
						}}>Confirm</button>
					}
					{obj.verified &&
						<button onClick={() => {
							window.location = "/";
						}}>Go Home</button>
					}
					{isVerifying &&
						<div className={"overlay"}>
							<LoadingState style={{ width: "100%", height: "100%" }} isShown={true} text={"Verifying..."} />
						</div>
					}
					{isDone &&
						<div className={"overlay confirm-done"} style={{ background: "#fff" }}>
							<i className={"material-icons"}>done</i>
							<Link to={this.getPath(obj.user)}>Go to profile</Link>
						</div>
					}
				</div>
			</Scaffold>
		);
	}
}

class ConfirmLogin extends Component {
	constructor(p) {
		super(p)
		this.state = {
			isLoading: true,
			isVerifying: false,
			isDone: false,
			error: false,
			obj: null,
			icon: "done",
			message: "Waiting..."
		};
	}

	componentDidMount() {
		this._isMounted = true;
		this.getData()
	}

	getData = () => {
		const _that = this;

		FakeData.post(FakeData.apiURL+"/auth_user?token=" + this.props.match.params.token + "&helper=" + this.props.match.params.user_id, {}, {
			success(res) {
				if (!_that._isMounted) {
					return;
				}

				if (res.logged) {
					_that.setState({ error: false, obj: null, isLoading: false, isDone: true, icon: "done", message: res.message });
				} else {
					_that.setState({ obj: null, error: true, isLoading: false, isDone: true, icon: "highlight_off", message: res.message });
				}
			},
			error() {
				_that.setState({ error: true, obj: null, isLoading: false, message: false });
			}
		})
	}

	render() {
		const { isLoading, isVerifying, error, obj, isDone, icon, message } = this.state;
		if (isLoading) {
			return (
				<Scaffold hideExtra={false}>
					<div style={{ width: "60vw", height: "45vh", background: "#fff" }}>
						<LoadingState style={{ width: "100%", height: "100%", background: "#fff" }} isShown={true} text={"Please wait while validating confirmation token"} />
					</div>
				</Scaffold>
			)
		}

		if (!message) {
			return (
				<Redirect to={{
					pathname: "/404",
					state: { from: this.props.location }
				}} />
			)
		}

		return (
			<Scaffold hideExtra={false}>
				<div style={{ width: "60vw", height: "45vh", background: "#fff" }} className={"confirm-pf-box"}>
					{isDone &&
						<div className={"overlay confirm-done"} style={{ background: "#fff" }}>
							<i className={"material-icons"}>{icon}</i>
							<span>{message}</span><br />
							<Link to={{ pathname: "/" }}>Go Home</Link>
						</div>
					}
				</div>
			</Scaffold>
		);
	}
}

class ChangeLogin extends Component {
	constructor(p) {
		super(p)
		this.state = {
			isLoading: true,
			isVerifying: false,
			isDone: false,
			error: false,
			current_pass: "",
			re_current_pass: "",
			errors: {
				current_pass: true,
				re_current_pass: true
			},
			obj: null,
			icon: "done",
			message: "Waiting..."
		};
	}

	componentDidMount() {
		this._isMounted = true;
		this.getData()
	}

	getData = () => {
		const _that = this;

		FakeData.post(FakeData.apiURL+"/auth_password_change?token=" + this.props.match.params.token, {}, {
			success(res) {
				if (!_that._isMounted) {
					return;
				}

				if (res.status) {
					_that.setState({ error: false, obj: res.data, isLoading: false, isDone: false, icon: "https", message: res.message });
				} else {
					_that.setState({ obj: null, error: true, isLoading: false, isDone: true, icon: "highlight_off", message: res.message });
				}
			},
			error() {
				_that.setState({ error: true, obj: null, isLoading: false, message: false });
			}
		})
	}

	removeData = () => {
		const _that = this;

		FakeData.post(FakeData.apiURL+"/auth_password_remove?token=" + this.props.match.params.token, {}, {
			success(res) {

			}
		})
	}

	changePassword() {
		const _that = this;

		const _data = {
			user: this.state.obj,
			pass_word: this.state.current_pass,
			password: SHA1(this.state.current_pass)
		}

		//console.log(_data)

		FakeData.post("/changePassword.php?auth0", _data, {
			success(res) {
				alert("Saved!");
				_that.setState({
					current_pass: "",
					re_current_pass: "",
					errors: {
						current_pass: false,
						re_current_pass: false
					},
					icon: "done",
					isDone: true,
					message: "Password was changed!"
				});
				_that.removeData()
			}
		}, true, "", null)
	}

	render() {
		const { isLoading, isVerifying, error, errors, current_pass, re_current_pass, obj, isDone, icon, message } = this.state;
		if (isLoading) {
			return (
				<Scaffold hideExtra={false}>
					<div style={{ width: "60vw", height: "45vh", background: "#fff" }}>
						<LoadingState style={{ width: "100%", height: "100%", background: "#fff" }} isShown={true} text={"Please wait while validating confirmation token"} />
					</div>
				</Scaffold>
			)
		}

		return (
			<Scaffold hideExtra={false}>
				<div style={{ width: "60vw", height: "45vh", background: "#fff" }} className={"confirm-pf-box"}>
					{!isDone &&
						<div className={"overlay confirm-done"} style={{ background: "#fff", padding: 30 }}>
							<i className={"material-icons"}>{icon}</i>
							<InputField label={"New Password"}>
								<input type="password" className={errors.current_pass ? "error" : ""} value={current_pass} placeholder="current password" onChange={(e) => {
									errors.current_pass = (e.target.value.length >= 7) ? false : true;
									this.setState({ current_pass: e.target.value, errors });
								}} />
							</InputField>
							<InputField label={"Repeat New Password"}>
								<input type="password" className={errors.re_current_pass ? "error" : ""} value={re_current_pass} placeholder="repeat password" onChange={(e) => {
									errors.re_current_pass = (current_pass.toLowerCase().indexOf(e.target.value.toLowerCase()) === 0 && current_pass.length === e.target.value.length) ? false : true;
									this.setState({ re_current_pass: e.target.value, errors });
								}} />
							</InputField>
							<button className="button" onClick={() => {
								this.changePassword();
							}} disabled={errors.current_pass || errors.re_current_pass}>Change Password</button>
						</div>
					}
					{isDone &&
						<div className={"overlay confirm-done"} style={{ background: "#fff" }}>
							<i className={"material-icons"}>{icon}</i>
							<span>{message}</span><br />
							<Link to={{ pathname: "/Login" }}>Login</Link>
						</div>
					}
				</div>
			</Scaffold>
		);
	}
}

export class Login extends Component {
	constructor(props) {
		super(props)
		this.state = this.props.isEmbed ? {
			user: {
				email: "",
				isHash: false,
				pass: ""
			},
			errorLogin: false,
			isLoading: false,
			isRegister: false,
			isLogged: false,
			forgotPassword: false,
			canSearch: false,
		} : {
				user: {
					email: "",
					isHash: false,
					pass: ""
				},
				errorLogin: false,
				isLoading: false,
				isRegister: false,
				canSearch: false,
				forgotPassword: false,
				isLogged: (getCookie("supotsu-user") === "" || getCookie("supotsu-user").split("-")[1] === undefined) ? false : true
			}

		this.signIn = this.signIn.bind(this);
	}

	componentDidMount() {
		var params = FakeData.getQueries(this.props.location.search);
		this.hasUrl = (params.ref) ? true : false;
		this.url = params.ref ? params.ref : null;
	}

	signWithGoogle() {
		const provider = new FireBase.auth.GoogleAuthProvider();
		const _that = this
		FireBase.auth().signInWithPopup(provider).then(function (result) {
			// This gives you a Google Access Token. You can use it to access the Google API.
			var token = result.credential.accessToken;
			// The signed-in user info.
			var user = result.user;
			_that.authFirebase(user)

			// ...
		}).catch(function (error) {
			console.log(error)
			// Handle Errors here.
			var errorCode = error.code;
			var errorMessage = error.message;
			// The email of the user's account used.
			var email = error.email;
			// The firebase.auth.AuthCredential type that was used.
			var credential = error.credential;
			// ...
		});
	}

	signWithFacebook() {
		const provider = new FireBase.auth.FacebookAuthProvider();
		const _that = this
		FireBase.auth().signInWithPopup(provider).then(function (result) {
			// This gives you a Google Access Token. You can use it to access the Google API.
			var token = result.credential.accessToken;
			// The signed-in user info.
			console.log(result.user)
			var user = result.user;
			//_that.authFirebase(user)

			// ...
		}).catch(function (error) {
			console.log(error)
			// Handle Errors here.
			var errorCode = error.code;
			var errorMessage = error.message;
			// The email of the user's account used.
			var email = error.email;
			// The firebase.auth.AuthCredential type that was used.
			var credential = error.credential;
			// ...
		});
	}

	signWithTwitter() {
		const provider = new FireBase.auth.TwitterAuthProvider();
		const _that = this
		FireBase.auth().signInWithPopup(provider).then(function (result) {
			// This gives you a Google Access Token. You can use it to access the Google API.
			var token = result.credential.accessToken;
			// The signed-in user info.
			var user = result.user;
			_that.authFirebase(user)

			// ...
		}).catch(function (error) {
			console.log(error)
			// Handle Errors here.
			var errorCode = error.code;
			var errorMessage = error.message;
			// The email of the user's account used.
			var email = error.email;
			// The firebase.auth.AuthCredential type that was used.
			var credential = error.credential;
			// ...
		});
	}

	authFirebase(user) {
		//console.log(user)
		const _that = this
		FireBase.auth().onAuthStateChanged(function (user) {
			if (user) {
				//console.log("Logged")
				_that.state.user.email = user.email
				_that.state.user.pass = user.uid
				_that.state.user.isHash = true
				_that.setState({
					user: _that.state.user
				});
				FakeData.setData("authUser", user)
				setTimeout(() => {
					_that.signIn()
				}, 500)
			} else {
				alert("Error Signing in with social network")
			}
		});
	}

	signIn() {
		const _that = this;
		const user = _that.state.user;
		//const _url = this.props.location.state.from.pathname;
		if (user.email === "__ADMIN__" && user.pass === "___ANGELS___") {
			_that.props.onLogin(null, true);
			return;
		}

		if (user.email === "__GUEST__" && user.pass === "guest") {
			_that.props.onLogin("guest", true);
			return;
		}

		if (user.email === "") {
			this.setState({
				emailErr: true
			});
			return;
		}

		if (user.pass.length < 1) {
			this.setState({
				passErr: true
			});
			return;
		}

		const dataTo = {
			user: user,
			device: {
				name: window.navigator.appVersion
			}
		}

		_that.setState({
			isLoading: true
		});

		FakeData.post("/signIn.php?auth0", dataTo, {
			success: ((res) => {
				if (!res.error) {
					if (_that.hasUrl) {
						FakeData.setData("yoo", res);
						fakeAuth.authenticate(() => {
							window.location = _that.url;
						}, res.username)

						return;
					}
					fakeAuth.authenticate(() => {
						_that.setState({
							isLogged: true,
							isLoading: false
						});
						FakeData.setData("yoo", res);
						_that.props.onLogin(res.username, false)
						FakeData.alert("Logged In Successfully!");
					}, res.username)
				} else {
					_that.setState({
						errorLogin: true,
						isLoading: false
					});
				}
			}),
			error: ((err) => {

			})
		}, true, "", (res) => { })
	}

	onRegister() {
		this.setState({ isRegister: true });
	}

	getData(user_id) {
		const _that = this

		FakeData.post('/getUserProfile.php?auth0&id=' + user_id + '&them=' + user_id, {}, {
			success: ((res) => {
				if (res.id) {
					fakeAuth.authenticate(() => {
						_that.setState({
							isLogged: true,
							isLoading: false
						});
						FakeData.setData("yoo", res);
						window.location = "/profile/" + user_id;
						FakeData.alert("Logged In Successfully!");
					}, user_id)

				} else {
					alert("Network Error");
				}
			}),
			error: ((err) => {

			})
		})
	}

	render = () => {
		const { isRegister, isLogged, forgotPassword, canSearch } = this.state;

		const { from } = this.props.location.state || { from: { pathname: _homeName } }
		if (isLogged) {
			return (
				<Redirect to={from} />
			)
		}

		if (isRegister) {
			return (
				<Redirect to={{ pathname: "/register", state: null }} />
			)
		}
		return (
			<div className="full-screen-page">
				<div className="log-reg-holder" style={{ width: "500px" }}>
					<div className="log-reg-holder-header">
						<img src="images/supotsu_logo.svg" />
					</div>
					<div className="log-reg-holder-body">
						{this.state.errorLogin &&
							<div style={{ padding: "10px 0px", color: "red" }}>Incorrect login details</div>
						}
						<div className="split-input">
							<div className="input-field">
								<span>Email/Username</span>
								<input name="user_email" className={(this.state.emailErr) ? "normal-input error" : "normal-input"} onChange={(e) => {
									const val = e.target.value
									this.state.user.email = val
									this.setState({
										user: this.state.user,
										emailErr: false
									});
								}} />
							</div>
							<div className="input-field">
								<span>Password</span>
								<input name="user_password" type="password" className={(this.state.passErr) ? "normal-input error" : "normal-input"} onChange={(e) => {
									const val = e.target.value
									this.state.user.pass = val
									this.setState({
										user: this.state.user,
										passErr: false
									});
								}} />
							</div>
						</div>
						<button className="gbl-btn" style={{ marginTop: "-10px" }} onClick={this.signIn.bind(this)}>Login</button>
						<div className="or-split">OR</div>
						<button className="gbl-btn" style={{ marginTop: "-5px" }} onClick={() => {
							this.setState({ forgotPassword: true });
						}}>Forgot Password?</button>
						<div className="or-split">Login with your social account</div>
						<SocialButton pref="" label="Facebook" src="images/facebook_icon_wht.svg" onClick={() => {
							this.signWithFacebook()
						}} />
						<SocialButton pref="" label="Twitter" src="images/twitter_icon_wht.svg" onClick={() => {
							this.signWithTwitter()
						}} />
						<SocialButton pref="" label="Google" src="images/google_icon.svg" onClick={() => {
							this.signWithGoogle()
						}} />
						<div className="or-split">OR</div>
						<button className="gbl-btn" onClick={() => this.onRegister()}>Register</button>
					</div>
				</div>
				{forgotPassword &&
					<Modal isOpen={forgotPassword} onClose={() => {
						this.setState({ forgotPassword: false })

					}}>
						<div className="add-place" style={{
							width: "45vw",
							maxHeight: "80vh"
						}}>
							<h2>Forgot Password?</h2>
							<InputField label={this.state.user.email.length > 5 ? "Confirm login for " + this.state.user.email : "Enter your username or email"}>
								<input value={this.state.user.email} disabled={this.state.isUserSet ? true : false} className={(this.state.emailErr) ? "normal-input error" : "normal-input"} onChange={(e) => {
									const val = e.target.value
									this.state.user.email = val
									this.setState({
										user: this.state.user,
										emailErr: false,
										isUserSet: false
									});
								}} />
							</InputField>
							{!canSearch &&
								<button disabled={this.state.user.email.length < 4} onClick={() => {
									this.setState({ canSearch: true });
								}}>Submit</button>
							}
							{canSearch && <ConfirmAccount onLogged={(user_id) => {
								this.getData(user_id)
							}} notMe={() => {
								this.state.user.email = ""
								this.setState({
									canSearch: false,
									user: this.state.user,
								})
							}} onUserLoaded={(user) => {
								this.setState({ isUserSet: true });
							}} key={this.state.user.email} value={this.state.user.email} />}
						</div>
					</Modal>
				}
			</div>
		);
	}
}

export class _HomeLogin extends Component{
	constructor(props){
		super(props)
		this.state = {
			user: {
				email: "",
				isHash: false,
				pass: ""
			},
			errorLogin: false,
			isLoading: false,
			isRegister: false,
			canSearch: false,
			forgotPassword: false,
			isLogged: (getCookie("supotsu-user") === "" || getCookie("supotsu-user").split("-")[1] === undefined) ? false : true
		}

		this.signIn = this.signIn.bind(this);
	}

	signWithGoogle() {
		const provider = new FireBase.auth.GoogleAuthProvider();
		const _that = this
		FireBase.auth().signInWithPopup(provider).then(function (result) {
			// This gives you a Google Access Token. You can use it to access the Google API.
			var token = result.credential.accessToken;
			// The signed-in user info.
			var user = result.user;
			_that.authFirebase(user)

			// ...
		}).catch(function (error) {
			console.log(error)
			// Handle Errors here.
			var errorCode = error.code;
			var errorMessage = error.message;
			// The email of the user's account used.
			var email = error.email;
			// The firebase.auth.AuthCredential type that was used.
			var credential = error.credential;
			// ...
		});
	}

	signWithFacebook() {
		const provider = new FireBase.auth.FacebookAuthProvider();
		const _that = this
		FireBase.auth().signInWithPopup(provider).then(function (result) {
			// This gives you a Google Access Token. You can use it to access the Google API.
			var token = result.credential.accessToken;
			// The signed-in user info.
			console.log(result.user)
			var user = result.user;
			//_that.authFirebase(user)

			// ...
		}).catch(function (error) {
			console.log(error)
			// Handle Errors here.
			var errorCode = error.code;
			var errorMessage = error.message;
			// The email of the user's account used.
			var email = error.email;
			// The firebase.auth.AuthCredential type that was used.
			var credential = error.credential;
			// ...
		});
	}

	signWithTwitter() {
		const provider = new FireBase.auth.TwitterAuthProvider();
		const _that = this
		FireBase.auth().signInWithPopup(provider).then(function (result) {
			// This gives you a Google Access Token. You can use it to access the Google API.
			var token = result.credential.accessToken;
			// The signed-in user info.
			var user = result.user;
			_that.authFirebase(user)

			// ...
		}).catch(function (error) {
			console.log(error)
			// Handle Errors here.
			var errorCode = error.code;
			var errorMessage = error.message;
			// The email of the user's account used.
			var email = error.email;
			// The firebase.auth.AuthCredential type that was used.
			var credential = error.credential;
			// ...
		});
	}

	authFirebase(user) {
		//console.log(user)
		const _that = this
		FireBase.auth().onAuthStateChanged(function (user) {
			if (user) {
				//console.log("Logged")
				_that.state.user.email = user.email
				_that.state.user.pass = user.uid
				_that.state.user.isHash = true
				_that.setState({
					user: _that.state.user
				});
				FakeData.setData("authUser", user)
				setTimeout(() => {
					_that.signIn()
				}, 500)
			} else {
				alert("Error Signing in with social network")
			}
		});
	}

	signIn() {
		const _that = this;
		const user = _that.state.user;
		//const _url = this.props.location.state.from.pathname;
		if (user.email === "__ADMIN__" && user.pass === "___ANGELS___") {
			_that.props.onLogin(null, true);
			return;
		}

		if (user.email === "__GUEST__" && user.pass === "guest") {
			_that.props.onLogin("guest", true);
			return;
		}

		if (user.email === "") {
			this.setState({
				emailErr: true
			});
			return;
		}

		if (user.pass.length < 1) {
			this.setState({
				passErr: true
			});
			return;
		}

		const dataTo = {
			user: user,
			device: {
				name: window.navigator.appVersion
			}
		}

		_that.setState({
			isLoading: true
		});

		FakeData.post("/signIn.php?auth0", dataTo, {
			success: ((res) => {
				if (!res.error) {
					if (_that.hasUrl) {
						FakeData.setData("yoo", res);
						fakeAuth.authenticate(() => {
							window.location = _that.url;
						}, res.username)

						return;
					}
					fakeAuth.authenticate(() => {
						_that.setState({
							isLogged: true,
							isLoading: false
						});
						FakeData.setData("yoo", res);
						_that.props.onLogin(res.username, false)
						FakeData.alert("Logged In Successfully!");
					}, res.username)
				} else {
					_that.setState({
						errorLogin: true,
						isLoading: false
					});
				}
			}),
			error: ((err) => {

			})
		}, true, "", (res) => { })
	}

	onRegister() {
		this.setState({ isRegister: true });
	}

	getData(user_id) {
		const _that = this

		FakeData.post('/getUserProfile.php?auth0&id=' + user_id + '&them=' + user_id, {}, {
			success: ((res) => {
				if (res.id) {
					fakeAuth.authenticate(() => {
						_that.setState({
							isLogged: true,
							isLoading: false
						});
						FakeData.setData("yoo", res);
						window.location = "/profile/" + user_id;
						FakeData.alert("Logged In Successfully!");
					}, user_id)

				} else {
					alert("Network Error");
				}
			}),
			error: ((err) => {

			})
		})
	}

	render(){
		const { isRegister, isLogged, forgotPassword, canSearch } = this.state;

		const { from } = this.props.location.state || { from: { pathname: _homeName } }
		if (isRegister) {
			return (
				<Redirect to={{ pathname: "/register", state: null }} />
			)
		}

		return(
			<div className="col-md-6" style={{
				paddingTop: 10
			}}>
				<div className="row">
					<div className="col-md-5">
						<label ref={(ref)=>{
							if(ref){
								ref.setAttribute("style","margin-bottom: 2px !important; color: #fff");
							}
						}} style={{ margin: 0, marginBottom: 10, color: "#fff" }}>Email</label>
						<input
							name="user_email"
							placeholder={"Email/Username"}
							className={this.state.emailErr?"input-lg error":"input-lg"}
							type="text"
							onChange={(e) => {
								const val = e.target.value
								this.state.user.email = val
								this.setState({
									user: this.state.user,
									emailErr: false
								});
							}}
						/>
					</div>
					<div className="col-md-5">
						<label ref={(ref)=>{
							if(ref){
								ref.setAttribute("style","margin-bottom: 2px !important; color: #fff");
							}
						}} style={{ margin: 0, marginBottom: 10, color: "#fff" }}>Password</label>
						<input
							name="user_password"
							placeholder={"Password"}
							className={this.state.passErr?"input-lg error":"input-lg"}
							type="password"
							onChange={(e) => {
								const val = e.target.value
								this.state.user.pass = val
								this.setState({
									user: this.state.user,
									passErr: false
								});
							}}
						/>
						<a onClick={()=>{
							this.setState({ forgotPassword: true });
						}} style={{
							marginTop: 2,
						}} className="forgot_btn">Forgotten password?</a>
					</div>
					<div className="col-md-2">
						<input
							style={{
								textAlign: "center",
								padding: "0px 0",
								marginTop: 18,
								marginBottom: 0
							}}
							name="login"
							defaultValue="Log in"
							className="btn log_btn"
							type="submit"
							onClick={this.signIn}
						/>
					</div>
				</div>
				<div className="row" style={{
					display:'flex',
					alignItems: 'center'
				}}>
					<div className="col-md-2 login">
						<h6>Login with</h6>{" "}
					</div>
					<div className="col-md-1">
						{" "}
						<div className="row">
							<div className="col-md-12">
								<a
									className="btn_facebook"
									onClick={this.signWithFacebook.bind(this)}
								/>
							</div>
						</div>
					</div>
					<div className="col-md-1">
						{" "}
						<div className="row">
							<div className="col-md-12">
								<a onClick={this.signWithTwitter.bind(this)}>
									<button className="btn_twitter" />
								</a>
							</div>
						</div>
					</div>
					<div className="col-md-1">
						{" "}
						<div className="row">
							<div className="col-md-12">
								<a
									className="btn_google"
									onClick={this.signWithGoogle.bind(this)}
								/>
							</div>
						</div>
					</div>
					<div className="col-md-7"> </div>
				</div>
				{forgotPassword &&
					<Modal isOpen={forgotPassword} onClose={() => {
						this.setState({ forgotPassword: false })

					}}>
						<div className="add-place" style={{
							width: "45vw",
							maxHeight: "80vh"
						}}>
							<h2>Forgot Password?</h2>
							<InputField label={this.state.user.email.length > 5 ? "Confirm login for " + this.state.user.email : "Enter your username or email"}>
								<input value={this.state.user.email} disabled={this.state.isUserSet ? true : false} className={(this.state.emailErr) ? "normal-input error" : "normal-input"} onChange={(e) => {
									const val = e.target.value
									this.state.user.email = val
									this.setState({
										user: this.state.user,
										emailErr: false,
										isUserSet: false
									});
								}} />
							</InputField>
							{!canSearch &&
								<button disabled={this.state.user.email.length < 4} onClick={() => {
									this.setState({ canSearch: true });
								}}>Submit</button>
							}
							{canSearch && <ConfirmAccount onLogged={(user_id) => {
								this.getData(user_id)
							}} notMe={() => {
								this.state.user.email = ""
								this.setState({
									canSearch: false,
									user: this.state.user,
								})
							}} onUserLoaded={(user) => {
								this.setState({ isUserSet: true });
							}} key={this.state.user.email} value={this.state.user.email} />}
						</div>
					</Modal>
				}
				{isLogged &&
					<Redirect to={from} />
				}
			</div>
		)
	}
}

class ConfirmAccount extends Component {
	constructor(p) {
		super(p)
		this.state = {
			error: false,
			isLoading: true,
			user: null,
			helper: null,
			isChange: false
		}
	}

	componentDidMount() {
		this._isMounted = true;
		this.io = false;
		const _that = this;
		this.getUser();
		this.setState({ token: SHA1(this.state.token + "" + this.props.value) });
		try {
			this.io = new window.io.connect(FakeData.apiURL+"/wsSecurity", { transports: ['polling', 'websocket'] });
			this.io.on("on_connected", (data) => {

			});

			this.io.on("notification", (data) => {
				console.log(data);
			})

			this.io.on("kill", (data) => {
				_that.io = false;
				if (_that.props.onLogged) {
					_that.props.onLogged(_that.state.user.user)
				}
			})

			this.io.on("autologged", (bool) => {
				if (bool) {
					_that.io.emit("autologged", true);
					_that.setState({ isLoading: true });
					if (_that.props.onLogged) {
						_that.props.onLogged(_that.state.user.user)
					}
				}
			})

			this.io.on("send_token", (bool) => {
				if (bool) {
					const _url = window.location.protocol + "//" + window.location.host + "/login/" + this.state.token + "/" + this.state.helper.user;
					//console.log("URI ", _url);
					//Send email to user .....
					//FakeData.post("/")
					_that.io.emit("send_token", {
						url: _url
					})
				}
			})
		} catch (error) {
			this.io = false;
		}
	}

	componentWillUnmount() {
		this._isMounted = false,
			this.io = false
	}

	selectHelper = (helper) => {
		const _that = this;
		if (_that.io) {
			_that.setState({ helper }, () => {
				_that.io.emit("on_connected", {
					//user_id: this.state.user.user,
					token: _that.state.token,
					user: helper,
					me: _that.state.user
				});
				if (_that.props.onUserLoaded) {
					_that.props.onUserLoaded(helper)
				}
			})
		} else {
			alert("Network error!");
		}
	}

	getUser() {
		const _that = this;
		const data = {
			email: this.props.value
		}

		FakeData.post("/getUserSettings.php?auth0", data, {
			success(res) {
				if (!_that._isMounted) {
					return;
				}
				if (res.error) {
					_that.setState({
						isLoading: false,
						error: true
					})
				} else {
					_that.setState({
						isLoading: false,
						error: false,
						user: res
					})
				}
			}
		})
	}

	getSettingUsers = () => {
		let _list = []
		if (this.state.user === null) {
			return [];
		}

		const settings = FakeData.listify(this.state.user['_']).filter((item, i) => {
			return item.sub === "login_auth_";
		})
		//console.log(settings[0].users)
		_list = settings[0] ? settings[0]['users'] : []
		return _list;
	}

	changePassword = () => {
		const _that = this;
		if (this.io) {
			const _token = SHA1(Date.now() + "_" + _that.state.user.name);
			const _url = window.location.protocol + "//" + window.location.host + "/change_password/" + _token;
			this.io.emit("change_password", {
				token: _token,
				me: _that.state.user,
				url: _url
			});
			if (_that.props.onUserLoaded) {
				_that.props.onUserLoaded(_that.state.user)
			}
			this.setState({ isChange: true })
		}
	}

	render() {
		const { isLoading, error, user, helper, isChange } = this.state;
		if (isLoading) {
			return (
				<LoadingState isShown={true} text={"Please wait..."} />
			);
		}

		if (error) {
			return (
				<EmptyState isShown={true} text={"No user found!"} />
			);
		}

		if (helper !== null) {
			return (
				<LoadingState isShown={true} text={"Waiting... for " + helper.name + " to confirm your login..."} />
			);
		}

		if (isChange) {
			return (
				<div style={{
					width: "100%"
				}}>
					<button onClick={() => {
						this.changePassword();
					}}>Send Link Again</button>
					<div className="or-split" style={{
						color: "#000"
					}}>OR</div>
					<button onClick={() => {
						this.setState({ isChange: false });
					}}>Cancel</button>
				</div>
			)
		}

		const users = FakeData.listify(this.getSettingUsers());
		return (
			<div style={{
				width: "100%"
			}}>
				<button onClick={() => {
					if (this.props.notMe) {
						this.props.notMe()
					}
				}}>Not You?</button>
				<div className="or-split" style={{
					color: "#000"
				}}>OR</div>
				<button onClick={() => {
					this.changePassword();
				}}>Change Password</button>
				{users.length > 0 &&
					<div className="or-split" style={{
						color: "#000"
					}}>OR</div>
				}
				{users.length > 0 &&
					<code style={{
						display: "block",
						padding: 10
					}}>
						Click on a friend, the they will receive an email with a link to auto log you in.
          <br /><br />
						<strong>NB </strong> : DO NOT CLOSE THIS WINDOW
        </code>
				}
				{users.length > 0 &&
					<div style={{
						width: "100%",
						display: "flex",
						flexDirection: 'row',
						alignItems: 'center',
						justifyContent: 'center',
					}}>
						{
							users.map((item, i) => {
								return (<div onClick={() => {
									this.selectHelper(item)
								}} key={i} style={{
									width: "calc(100% / 3 - 60px)",
									margin: 10
								}}>
									<img src={item.image} style={{
										width: "100%",
										height: "100%",
										borderRadius: "100%"
									}} />
								</div>)
							})
						}
					</div>
				}
			</div>
		)
	}
}

export class Register extends React.Component {
	constructor(props) {
		super(props)
		console.log(this.props.location.state)
		this.state = this.props.location.state && this.props.location.state.data ?this.props.location.state.data:{
			user: {
				name: "",
				surname: "",
				displayName: "",
				gender: "",
				photoUrl: "",
				bday: null,
				email: "",
				pass: "",
				uid: "",
				isParent: this.props.isParent ? this.props.isParent : false,
				provider: "Supotsu",
				isSocialAuth: false,
				isAfterReg: false,
				sportsFollowed: [],
				mySport: [],
				isHash: false,
				address: "",
				suburbs: "",
				postalCode: "",
				country: "",
				state: "",
				isUnderAge: false,
				parent: this.props.isParent ? this.props.user : null,
				coach: null,
			},
			errorCreate: false,
			year: false,
			isAddingFollow: false,
			isAddingPlay: false,
			suggested: "",
			agreement: {
				terms: {
					label: "Term & Conditions",
					agreed: false,
					error: false
				},
				privacy: {
					label: "Term & Conditions",
					agreed: false,
					error: false
				}
			},
			isDone: false,
			approvals:[]
		}
	}

	componentDidMount() {
		const _that = this;
		AsyncStorage.getItem('user-year').then((value) => {
			_that.setState({ year: value ? value : false });
		}).catch(() => {

		});
	}

	signWithGoogle() {
		const _that = this
		const provider = new FireBase.auth.GoogleAuthProvider();
		FireBase.auth().signInWithPopup(provider).then(function (result) {
			// This gives you a Google Access Token. You can use it to access the Google API.
			var token = result.credential.accessToken;
			// The signed-in user info.
			var user = result.user;
			FakeData.setData("authUser", user)
			var names = user.displayName.split(" ")
			console.log(token)
			_that.state.user.name = names[0]
			_that.state.user.surname = names[1]
			_that.state.user.email = user.email
			_that.state.user.photoUrl = (user.photoURL) ? user.photoURL : ""
			_that.state.user.provider = "Google"
			//_that.state.user.isSocialAuth = user.emailVerified
			_that.state.user.uid = user.uid
			_that.state.user.pass = user.uid
			_that.state.user.isHash = true
			_that.setState({
				user: _that.state.user
			});
			// ...
		}).catch(function (error) {
			console.log(error)
			// Handle Errors here.
			var errorCode = error.code;
			var errorMessage = error.message;
			// The email of the user's account used.
			var email = error.email;
			// The firebase.auth.AuthCredential type that was used.
			var credential = error.credential;
			// ...
		});
	}

	signWithFacebook() {
		const _that = this
		const provider = new FireBase.auth.FacebookAuthProvider();
		provider.addScope("public_profile");
		provider.addScope("user_hometown");
		provider.addScope("user_location");
		FireBase.auth().signInWithPopup(provider).then(function (result) {
			// This gives you a Google Access Token. You can use it to access the Google API.
			var token = result.credential.accessToken;
			// The signed-in user info.
			var user = result.user;
			FakeData.setData("authUser", user)
			var names = user.displayName.split(" ")
			//console.log(user)
			_that.state.user.name = names[0]
			_that.state.user.surname = names[1]
			_that.state.user.email = user.email
			_that.state.user.photoUrl = (user.photoURL) ? user.photoURL : ""
			_that.state.user.provider = "Facebook"
			//_that.state.user.isSocialAuth = user.emailVerified
			_that.state.user.uid = user.uid
			_that.state.user.pass = user.uid
			_that.state.user.isHash = true
			_that.setState({
				user: _that.state.user
			});
			// ...
		}).catch(function (error) {
			console.log(error)
			// Handle Errors here.
			var errorCode = error.code;
			var errorMessage = error.message;
			// The email of the user's account used.
			var email = error.email;
			// The firebase.auth.AuthCredential type that was used.
			var credential = error.credential;
			// ...
		});
	}

	signWithTwitter() {
		const _that = this
		const provider = new FireBase.auth.TwitterAuthProvider();
		FireBase.auth().signInWithPopup(provider).then(function (result) {
			// This gives you a Google Access Token. You can use it to access the Google API.
			var token = result.credential.accessToken;
			// The signed-in user info.
			var user = result.user;
			FakeData.setData("authUser", user)
			var names = user.displayName.split(" ")
			_that.state.user.name = names[0]
			_that.state.user.surname = (names[1] === null) ? "" : names[1]
			_that.state.user.email = (user.email === null) ? "" : user.email
			_that.state.user.photoUrl = (user.photoURL) ? user.photoURL : ""
			_that.state.user.provider = "Twitter"
			//_that.state.user.isSocialAuth = user.emailVerified
			_that.state.user.uid = user.uid
			_that.state.user.pass = user.uid
			_that.state.user.isHash = true
			_that.setState({
				user: _that.state.user
			});
			// ...
		}).catch(function (error) {
			console.log(error)
			// Handle Errors here.
			var errorCode = error.code;
			var errorMessage = error.message;
			// The email of the user's account used.
			var email = error.email;
			// The firebase.auth.AuthCredential type that was used.
			var credential = error.credential;
			// ...
		});
	}

	saveGeneric() {
		const _that = this;
		const user = this.state.user;
		if (!_that.state.agreement.terms.agreed) {
			const terms = _that.state.agreement.terms;
			terms.error = true;
			_that.state.agreement.terms = terms;
			_that.setState({ agreement: _that.state.agreement });
			FakeData.alert("Agree to terms and conditions!");
			return;
		}

		if (user.name === "") {
			this.setState({ nameErr: true });
			return;
		}

		if (user.surname === "") {
			this.setState({ surnameErr: true });
			return;
		}

		if (user.displayName === "" || (user.displayName.indexOf(' ') > -1)) {
			this.setState({ usernameError: true });
			return;
		}

		if (user.email === "" || (user.email.indexOf('@') === -1 && user.email.indexOf('.') === -1)) {
			this.setState({ emailErr: true });
			return;
		}

		if (user.pass.length < 7 && user.provider === "Supotsu") {
			this.setState({ passErr: true });
			return;
		}

		if (user.pass !== user.confirmPass && user.provider === "Supotsu") {
			this.setState({ passTooErr: true });
			return;
		}

		if (user.bday === null) {
			this.setState({ bDayErr: true });
			return;
		}

		if (user.isUnderAge && user.parent === null) {
			FakeData.alert('Please enter your parent details');
			return;
		}

		if (user.isUnderAge && user.parent !== null && user.parent.name === '') {
			FakeData.alert('Please enter your parent name');
			return;
		}

		if (user.gender === "") {
			this.setState({ genErr: true });
			return;
		}

		if (user.location === "") {
			this.setState({ locErr: true });
			return;
		}

		if (user.address === "") {
			//this.setState({ addressErr: true });
			//return;
		}

		if (user.suburbs === "") {
			//this.setState({ suburbErr: true });
			//return;
		}

		if (user.postalCode === "") {
			//this.setState({ postalCodeErr: true });
			//return;
		}

		if (user.country === "") {
			this.setState({ countryErr: true });
			return;
		}

		const dataTo = {
			user: this.state.user
		}

		FakeData.post("/registerUser.php?auth0", dataTo, {
			success: ((res) => {
				if (res.error) {
					_that.setState({ errorCreate: true, isDoneReg: false, usernameError: res.isUsernameError, emailErr: res.isEmailError, suggested: res.suggested });
				} else {
					_that.agreement({
						id: res.id,
						type: "F"
					});
					_that.getApproves();
					_that.setState({ errorCreate: false, user: res });
				}
			}),
			error: ((err) => {
				console.log(err)
			})
		}, true, "", () => { })
	}

	saveSocial() {
		const _that = this;
		const dataTo = {
			user: this.state.user
		}

		if (!_that.state.agreement.terms.agreed) {
			const terms = _that.state.agreement.terms;
			terms.error = true;
			_that.state.agreement.terms = terms;
			_that.setState({ agreement: _that.state.agreement });
			FakeData.alert("Agree to terms and conditions!");
			return;
		}

		FakeData.post("/registerUser.php?auth0", dataTo, {
			success: ((res) => {
				if (res.error) {
					_that.setState({ errorCreate: true, usernameError: res.isUsernameError, emailErr: res.isEmailError, suggested: res.suggested });
				} else {
					_that.agreement({
						id: res.id,
						type: "F"
					});
					_that.getApproves();
					_that.setState({ errorCreate: false, user: res });
				}
			}),
			error: ((err) => {
				console.log(err)
			})
		}, true, "", () => { })
	}

	evtDateChgange(e) {
		const _that = this;
		const val = e.target.value;
		_that.state.user.bday = val;
		_that.setState({ user: _that.state.user, bDayErr: false });
	}

	onSportsFollowAdd(arr) {
		this.state.user.sportsFollowed = arr;
		this.setState({
			user: this.state.user,
			followedErr: (arr.length === 0) ? true : false,
			isAddingFollow: false
		});
	}

	onSportsPlayAdd(arr) {
		if (arr === null) {
			this.setState({
				playedErr: (this.state.user.mySport.length === 0) ? true : false,
				isAddingPlay: false
			});

			return;
		}

		this.state.user.mySport.push(arr);
		this.setState({
			user: this.state.user,
			playedErr: (arr.length === 0) ? true : false,
			isAddingPlay: false
		});
	}

	saveSports() {
		//const _that = this;
		if (this.state.user.sportsFollowed.length === 0) {
			this.setState({
				followedErr: true
			});
			return
		}

		if (this.state.user.mySport.length === 0) {
			this.setState({
				playedErr: true
			});
			return
		}

		const dataTo = {
			userId: this.state.user.id,
			sportsFollowed: this.state.user.sportsFollowed,
			sportsPlayed: this.state.user.mySport
		}

		//console.log(dataTo)
		const _that = this

		FakeData.post("/saveSports.php?auth0", dataTo, {
			success: ((res) => {
				if (!res.error) {

					if (_that.props.isEmbed) {
						_that.props.onRegister(_that.state.user.user);
						return;
					}

					fakeAuth.authenticate(() => {
						_that.setState({
							isDone: true,
							isLoading: false
						});
						FakeData.setData("yoo", _that.state.user.user);
						_that.props.onRegister(_that.state.user.username)
					}, _that.state.user.username)
				}
			}),
			error: ((err) => {

			})
		}, true, "Registered Successfully!", (res) => { })
	}

	renderBody = (jsx, isModal = false) => {
		const { user } = this.state;
		if (!isModal) {
			return jsx;
		} else {
			return (
				<Modal>
					{jsx}
				</Modal>
			);
		}
	}

	agreement = (user = { id: 0, type: "F" }) => {
		const _that = this;
		const { agreement } = this.state;
		const _data = {
			user,
			agreement
		}

		FakeData.post(FakeData.apiURL+"/admin/agreement/agree", _data, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			success(err) {

			},
			error(err) {

			}
		})
	}

	getApproves = () => {
		const _data = {
			email: this.state.user.email
		};
		const _that = this;

		FakeData.post('/getAwaitingEmailApprovals.php?auth0', _data, {
			success(res){
				_that.setState({ approvals: FakeData.listify(res) });
			},
			error(er){

			}
		})
	}

	getCountryName = (name='') => {
		if(name==='USA'){
			return 'United States';
		} else if(name==='UK'){
			return 'United Kingdom'
		} else{
			return name;
		}
	}

	render() {
		const { user, agreement, year, approvals, isDoneReg } = this.state;
		const { isEmbed, isOpen } = this.props;
		if (this.state.isDone) {
			return (
				<Redirect to={{ path: "/create", state: { to: "/profile/" + this.state.user.username + "?sInit=about" } }} />
			)
		}
		const elem = <ScrollView className="full-screen-page" style={{ overflowY: "auto" }}>
			{this.state.user.isAfterReg &&
				<div className="after-register-profile">
					<div className="after-register-profile-content">
						<div className="after-register-profile-content-head">
							<img src="images/add_blu.svg" />
							<h1>Personal Profile</h1>
						</div>
						<div className="after-register-profile-content-item">
							<h3>Sports I follow</h3>
							<div className={(this.state.followedErr) ? "added-sports-list error" : "added-sports-list"}>
								{
									this.state.user.sportsFollowed.map((item, i) => {

										return (
											<div key={i} className="added-sport-item">
												<img src={item.image.replace("_wht", "")} />
											</div>
										)
									})
								}
								<div className="add-to-sport" onClick={() => {
									this.setState({
										isAddingFollow: true
									});
								}}>
									<img src="images/add_blu.svg" /> Add
              </div>
							</div>
						</div>
						<div className="after-register-profile-content-item">
							<h3>Sports I play</h3>
							<div className={(this.state.playedErr) ? "added-sports-list error" : "added-sports-list"}>
								{
									this.state.user.mySport.map((item, i) => {
										return (
											<div key={i} className="added-sport-item">
												<img src={item.image.replace("_wht", "")} />
											</div>
										)
									})
								}
								<div className="add-to-sport" onClick={() => {
									this.setState({
										isAddingPlay: true
									});
								}}>
									<img src="images/add_blu.svg" /> Add
              </div>
							</div>
						</div>
					</div>
					<div tabIndex="0" className="after-register-profile-button gbl-btn" onClick={this.saveSports.bind(this)}>Save Profile</div>
					<AddSportFollow isOpen={this.state.isAddingFollow} onClose={this.onSportsFollowAdd.bind(this)} />
					<AddSportPlay isOpen={this.state.isAddingPlay} onClose={this.onSportsPlayAdd.bind(this)} />
				</div>
			}
			{!this.state.user.isAfterReg &&
				<div className="log-reg-holder" style={{ width: "600px", marginTop: isEmbed || isDoneReg ? "0px" : "200px" }}>
					<div className="log-reg-holder-header">
						{(this.state.user.photoUrl !== "" && this.isSet) &&
							<img src={this.state.user.photoUrl} className="social-picture" />
						}
						<img src="images/supotsu_logo.svg" />
					</div>
					{this.state.user.isSocialAuth &&
						<div className="log-reg-holder-body">
							{this.state.errorCreate &&
								<div style={{ padding: "10px 0px", color: "red" }}>{(this.state.usernameError) ? "Account with this email address or username already exists, try this one : " + this.state.suggested : "Account with this email address already exists"}</div>
							}
							<button className="gbl-btn" onClick={() => { this.saveSocial() }}>Continue as {this.state.user.name}</button>
						</div>
					}
					{!this.state.user.isSocialAuth &&
						<div className="log-reg-holder-body">
							{this.state.errorCreate &&
								<div style={{ padding: "10px 0px", color: "red" }}>{(this.state.usernameError) ? "Account with this email address or username already exists, try this one : " + this.state.suggested : "Account with this email address already exists"}</div>
							}
							{!isDoneReg && <div className="split-input">
								<div className="input-field">
									<span>First Name</span>
									<input value={this.state.user.name} className={(this.state.nameErr) ? "normal-input error" : "normal-input"} onChange={(e) => {
										const val = e.target.value
										this.state.user.name = val;
										this.setState({ user: this.state.user, nameErr: false });
									}} />
								</div>
								<div className="input-field">
									<span>Last Name</span>
									<input type="" value={this.state.user.surname} className={(this.state.surnameErr) ? "normal-input error" : "normal-input"} onChange={(e) => {
										const val = e.target.value
										this.state.user.surname = val;
										this.setState({ user: this.state.user, surnameErr: false });
									}} />
								</div>
							</div>}
							{isDoneReg &&
								<div style={{ padding: "10px 10px", textAlign: "center", background: "rgba(255, 255, 255,0.9)", color: "#000", marginBottom: "10px" }}>
									Please supply us with the following information, so that we can show teams, clubs and institution around you
								</div>
							}
							{!isDoneReg && <div className="split-input">
								<div className="input-field">
									<span>Username</span>
									<input value={this.state.user.displayName} className={(this.state.usernameError) ? "normal-input error" : "normal-input"} onChange={(e) => {
										const val = e.target.value
										this.state.user.displayName = val.toLowerCase();
										this.setState({ user: this.state.user, usernameError: (val.indexOf(" ") > -1) });
									}} />
								</div>
								<div className="input-field">
									<span>Email</span>
									<input value={this.state.user.email} type="email" className={(this.state.emailErr) ? "normal-input error" : "normal-input"} onChange={(e) => {
										const val = e.target.value
										let err = (val.indexOf('@') > -1 && val.indexOf('.') > -1) ? false : true
										this.state.user.email = val;
										this.setState({ user: this.state.user, emailErr: err });
									}} />
								</div>
							</div>}
							{this.state.user.provider === "Supotsu" && !isDoneReg &&
								<div className="split-input">
									<div className="input-field">
										<span>Password</span>
										<input type="password" value={this.state.user.pass} className={(this.state.passErr) ? "normal-input error" : "normal-input"} onChange={(e) => {
											const val = e.target.value
											this.state.user.pass = val;
											let err = (val.length < 7) ? true : false
											this.setState({ user: this.state.user, passErr: err });
										}} />
									</div>
									<div className="input-field">
										<span>Repeat Password</span>
										<input type="password" value={this.state.user.confirmPass} className={(this.state.passTooErr) ? "normal-input error" : "normal-input"} onChange={(e) => {
											const val = e.target.value
											this.state.user.confirmPass = val;
											let err = (this.state.user.pass !== val) ? true : false
											this.setState({ user: this.state.user, passTooErr: err });
										}} />
									</div>
								</div>
							}

							{!isDoneReg && <div className={(this.state.bDayErr) ? "input-field error" : "input-field"}>
								<span>Birth Date</span>
								<DatePicker blankInit={true} withYear={true} year={year} withMonth={true} withDay={true} onChangeDate={(d) => {
									const _that = this;
									_that.state.user.bday = d;
									const arr = new Date(d).getFullYear();
									const date = new Date().getFullYear();
									if (arr < date) {
										AsyncStorage.setItem('user-year', arr).then(() => { }).catch(() => { })
									}
									const age = year ? date - year : date - arr;
									const isTrue = age <= 13 ? true : false;
									_that.state.user.isUnderAge = isTrue;
									_that.state.user.age = age;
									_that.state.user.parent = isTrue ? _that.state.user.parent : null;
									_that.state.user.coach = isTrue ? _that.state.user.coach : null;

									_that.setState({ user: _that.state.user, bDayErr: false });
								}} />
							</div>}
							{user.isUnderAge && !user.isParent &&
								<div style={{ padding: "10px 10px", textAlign: "center", background: "#fff", color: "#000", marginBottom: "15px" }}>
									The minimum age limit for users of Supotsu site and app is 8 years of age. You have told us that you are {this.state.user.age} years of age, and as such you need the permission of a parent or legal guardian to make your profile live, please fill in their details below.
              </div>
							}
							{user.isUnderAge && !user.isParent &&
								<div className={(this.state.user.parent && !this.state.user.parent.id) || (this.state.user.parent && this.state.user.parent.id) ? "split-input" : "input-field"}>
									<InputFieldUserPicker error={user.isUnderAge && user.parent === null ? true : user.parent === user.coach ? true : false} label={"Parent/Guardian Email"} onSelectedItem={(item, isEmail = false) => {
										this.state.user.parent = item;
										this.setState({ user });
									}} />
									{this.state.user.parent && !this.state.user.parent.id &&
										<InputField label={"Parent/Guardian  Name"}>
											<input className={(user.isUnderAge && user.parent === null ? true : user.parent === user.coach) ? "normal-input error" : "normal-input"} value={user.parent.name} onChange={(e) => {
												const { value } = e.target;
												user.parent.name = value;
												this.setState({ user });
											}} />
										</InputField>
									}
									{this.state.user.parent && this.state.user.parent.id &&
										<InputField label={"Parent/Guardian  Name"}>
											<input className={(user.isUnderAge && user.parent === null ? true : user.parent === user.coach) ? "normal-input error" : "normal-input"} value={user.parent.name} disabled={true} />
										</InputField>
									}
								</div>
							}
							{!isDoneReg && <div className="split-input" style={{ marginTop: "-8px" }}>
								<div onClick={() => {
									this.state.user.gender = "female"
									this.setState({
										user: this.state.user
									});
								}}><input className={(this.state.genErr) ? "error" : ""} type="radio" readOnly name="gender" checked={(this.state.user.gender === "female") ? true : false} /><label style={{ color: "#fff" }}>Female</label></div>
								<div onClick={() => {
									this.state.user.gender = "male"
									this.setState({
										user: this.state.user
									});
								}}><input className={(this.state.genErr) ? "error" : ""} type="radio" readOnly name="gender" checked={(this.state.user.gender === "male") ? true : false} /><label style={{ color: "#fff" }}>Male</label></div>
							</div>}
							{!isDoneReg && <div className="input-field" style={{ marginTop: "10px" }}>
								<span>Your Location</span>
								<Geosuggest initialValue={this.state.user.location} className={this.state.locErr?"error":""} ref={(ref) => this.placeElem = ref} highlightMatch={true} onSuggestSelect={(item) => {
									const val = item.label;
									console.log(item)
									this.state.user.location = val;
									const _s = val.split(", ");
									this.state.user.country = this.getCountryName(_s[_s.length-1]);
									this.setState({ user: this.state.user, locErr: false });
									if (this.placeElem != null) {
										this.placeElem.blur()
									}
								}} />
							</div>}
							<div className="split-input">
								<div className="input-field">
									<span>Address</span>
									<input value={this.state.user.address} className={(this.state.addressErr) ? "normal-input error" : "normal-input"} onChange={(e) => {
										const val = e.target.value
										this.state.user.address = val;
										this.setState({ user: this.state.user, addressErr: false });
									}} />
								</div>
								<div className="input-field">
									<span>Suburbs</span>
									<input type="" value={this.state.user.suburbs} className={(this.state.suburbErr) ? "normal-input error" : "normal-input"} onChange={(e) => {
										const val = e.target.value
										this.state.user.suburbs = val;
										this.setState({ user: this.state.user, suburbErr: false });
									}} />
								</div>
							</div>
							{this.state.user.country !== "" &&
								<div className="input-field">
									<span>State/Province</span>
									<RegionDropdown classes={(this.state.stateErr) ? "error" : ""}
										country={this.state.user.country}
										value={this.state.user.state}

										onChange={(val) => {
											this.state.user.state = val;
											this.setState({ user: this.state.user, stateErr: false });
										}} />
								</div>
							}
							<div className="split-input">
								<div className="input-field">
									<span>Postal Code</span>
									<input type={"number"} min={1000} max={99999} value={this.state.user.postalCode} className={(this.state.postalCodeErr) ? "normal-input error" : "normal-input"} onChange={(e) => {
										const val = e.target.value
										this.state.user.postalCode = val;
										this.setState({ user: this.state.user, postalCodeErr: false });
									}} />
								</div>
								<div className="input-field">
									<span>Country</span>
									<CountryDropdown classes={(this.state.countryErr) ? "error" : ""}
										value={this.state.user.country}
										onChange={(val) => {
											this.state.user.country = val;
											this.setState({ user: this.state.user, countryErr: false, stateErr: true });
										}} />
								</div>
							</div>

							{!isDoneReg && <div className="or-split">Terms and Agreement</div>}
							{!isDoneReg &&<div style={{ padding: "10px 10px", textAlign: "center", background: "rgba(255, 255, 255,0.9)", color: "#000", marginBottom: "15px" }}>
								Before you create your account, you need agree to our <a href="somepage.xyz">Terms & Conditions</a> and/or <a href="somepage.xyz">Terms of Privacy.</a>
							</div>}
							{!isDoneReg &&
								<div className="split-input" style={{ margin: "15px 0px" }}>
									<div onClick={() => {
										agreement.terms.agreed = !agreement.terms.agreed;
										agreement.terms.error = agreement.terms.agreed ? false : true;
										this.setState({
											agreement
										});
									}}><input className={(agreement.terms.error) ? "error" : ""} type="radio" readOnly name="terms" checked={agreement.terms.agreed} /><label style={{ color: "#fff" }}><a style={{ color: "#fff" }}>Terms and Conditions agreement</a></label></div>
									{this.is &&
									<div onClick={() => {
										agreement.privacy.agreed = !agreement.privacy.agreed;
										agreement.privacy.error = agreement.privacy.agreed ? false : true;
										this.setState({
											agreement
										});
									}}><input className={(agreement.privacy.error) ? "error" : ""} type="radio" readOnly name="privacy" checked={agreement.privacy.agreed} /><label style={{ color: "#fff" }}><a href={""} style={{ color: "#fff" }}>Terms of Privacy</a></label></div>}
								</div>
							}


							<button className="gbl-btn" onClick={() => this.saveGeneric()}>{isDoneReg?"Continue":"Register"}</button>
							{!isDoneReg && <div className="or-split">OR</div>}
							{!isDoneReg && <SocialButton pref="Sign up with " label="Facebook" src="images/facebook_icon_wht.svg" onClick={() => { this.signWithFacebook() }} />}
							{!isDoneReg && <SocialButton pref="Sign up with " label="Twitter" src="images/twitter_icon_wht.svg" onClick={() => { this.signWithTwitter() }} />}
							{!isDoneReg && <SocialButton pref="Sign up with " label="Google" src="images/google_icon.svg" onClick={() => { this.signWithGoogle() }} />}
						</div>
					}
				</div>
			}
			{approvals.length > 0 &&
				<ParentApproveModal user={this.state.user} approvals={approvals}/>
			}
		</ScrollView>;
		if (!isEmbed) {
			return (elem);
		} else {
			return (
				<Modal isTransparent={true} isOpen={isOpen} onClose={() => this.props.onClose()}>
					{elem}
				</Modal>
			);
		}
	}
}

class _HomeReg extends React.Component {
	constructor(p){
		super(p)
		this.state = {
			user: {
				name: "",
				surname: "",
				displayName: "",
				gender: "",
				photoUrl: "",
				bday: null,
				email: "",
				pass: "",
				uid: "",
				isParent: this.props.isParent ? this.props.isParent : false,
				provider: "Supotsu",
				isSocialAuth: false,
				isAfterReg: false,
				sportsFollowed: [],
				mySport: [],
				isHash: false,
				address: "",
				suburbs: "",
				postalCode: "",
				country: "",
				state: "",
				isUnderAge: false,
				parent: this.props.isParent ? this.props.user : null,
				coach: null,
			},
			errorCreate: false,
			year: false,
			isAddingFollow: false,
			isAddingPlay: false,
			suggested: "",
			agreement: {
				terms: {
					label: "Term & Conditions",
					agreed: false,
					error: false
				},
				privacy: {
					label: "Term & Conditions",
					agreed: false,
					error: false
				}
			},
			isDone: false,
			isDoneReg: false,
			approvals:[]
		}
	}

	componentDidMount() {
		const _that = this;
		AsyncStorage.getItem('user-year').then((value) => {
			_that.setState({ year: value ? value : false });
		}).catch(() => {

		})
	}

	signWithGoogle() {
		const _that = this
		const provider = new FireBase.auth.GoogleAuthProvider();
		FireBase.auth().signInWithPopup(provider).then(function (result) {
			// This gives you a Google Access Token. You can use it to access the Google API.
			var token = result.credential.accessToken;
			// The signed-in user info.
			var user = result.user;
			FakeData.setData("authUser", user)
			var names = user.displayName.split(" ")
			console.log(token)
			_that.state.user.name = names[0]
			_that.state.user.surname = names[1]
			_that.state.user.email = user.email
			_that.state.user.photoUrl = (user.photoURL) ? user.photoURL : ""
			_that.state.user.provider = "Google"
			//_that.state.user.isSocialAuth = user.emailVerified
			_that.state.user.uid = user.uid
			_that.state.user.pass = user.uid
			_that.state.user.isHash = true
			_that.setState({
				user: _that.state.user
			});
			// ...
		}).catch(function (error) {
			console.log(error)
			// Handle Errors here.
			var errorCode = error.code;
			var errorMessage = error.message;
			// The email of the user's account used.
			var email = error.email;
			// The firebase.auth.AuthCredential type that was used.
			var credential = error.credential;
			// ...
		});
	}

	signWithFacebook() {
		const _that = this
		const provider = new FireBase.auth.FacebookAuthProvider();
		provider.addScope("public_profile");
		provider.addScope("user_hometown");
		provider.addScope("user_location");
		FireBase.auth().signInWithPopup(provider).then(function (result) {
			// This gives you a Google Access Token. You can use it to access the Google API.
			var token = result.credential.accessToken;
			// The signed-in user info.
			var user = result.user;
			FakeData.setData("authUser", user)
			var names = user.displayName.split(" ")
			//console.log(user)
			_that.state.user.name = names[0]
			_that.state.user.surname = names[1]
			_that.state.user.email = user.email
			_that.state.user.photoUrl = (user.photoURL) ? user.photoURL : ""
			_that.state.user.provider = "Facebook"
			//_that.state.user.isSocialAuth = user.emailVerified
			_that.state.user.uid = user.uid
			_that.state.user.pass = user.uid
			_that.state.user.isHash = true
			_that.setState({
				user: _that.state.user
			});
			// ...
		}).catch(function (error) {
			console.log(error)
			// Handle Errors here.
			var errorCode = error.code;
			var errorMessage = error.message;
			// The email of the user's account used.
			var email = error.email;
			// The firebase.auth.AuthCredential type that was used.
			var credential = error.credential;
			// ...
		});
	}

	signWithTwitter() {
		const _that = this
		const provider = new FireBase.auth.TwitterAuthProvider();
		FireBase.auth().signInWithPopup(provider).then(function (result) {
			// This gives you a Google Access Token. You can use it to access the Google API.
			var token = result.credential.accessToken;
			// The signed-in user info.
			var user = result.user;
			FakeData.setData("authUser", user)
			var names = user.displayName.split(" ")
			_that.state.user.name = names[0]
			_that.state.user.surname = (names[1] === null) ? "" : names[1]
			_that.state.user.email = (user.email === null) ? "" : user.email
			_that.state.user.photoUrl = (user.photoURL) ? user.photoURL : ""
			_that.state.user.provider = "Twitter"
			//_that.state.user.isSocialAuth = user.emailVerified
			_that.state.user.uid = user.uid
			_that.state.user.pass = user.uid
			_that.state.user.isHash = true
			_that.setState({
				user: _that.state.user
			});
			// ...
		}).catch(function (error) {
			console.log(error)
			// Handle Errors here.
			var errorCode = error.code;
			var errorMessage = error.message;
			// The email of the user's account used.
			var email = error.email;
			// The firebase.auth.AuthCredential type that was used.
			var credential = error.credential;
			// ...
		});
	}
	
	saveGeneric() {
		const _that = this;
		const user = this.state.user;
		if (!_that.state.agreement.terms.agreed) {
			const terms = _that.state.agreement.terms;
			terms.error = true;
			_that.state.agreement.terms = terms;
			_that.setState({ agreement: _that.state.agreement });
			FakeData.alert("Agree to terms and conditions!");
			return;
		}

		if (user.name === "") {
			this.setState({ nameErr: true });
			return;
		}

		if (user.surname === "") {
			this.setState({ surnameErr: true });
			return;
		}

		if (user.displayName === "" || (user.displayName.indexOf(' ') > -1)) {
			this.setState({ usernameError: true });
			return;
		}

		if (user.email === "" || (user.email.indexOf('@') === -1 && user.email.indexOf('.') === -1)) {
			this.setState({ emailErr: true });
			return;
		}

		if (user.pass.length < 7 && user.provider === "Supotsu") {
			this.setState({ passErr: true });
			return;
		}

		if (user.pass !== user.confirmPass && user.provider === "Supotsu") {
			this.setState({ passTooErr: true });
			return;
		}

		if (user.bday === null) {
			this.setState({ bDayErr: true });
			return;
		}

		if (user.isUnderAge && user.parent === null) {
			FakeData.alert('Please enter your parent details');
			return;
		}

		if (user.isUnderAge && user.parent !== null && user.parent.name === '') {
			FakeData.alert('Please enter your parent name');
			return;
		}

		if (user.gender === "") {
			this.setState({ genErr: true });
			return;
		}

		if (user.location === "") {
			this.setState({ locErr: true });
			FakeData.alert("Enter your location");
			return;
		}

		this.setState({ isDoneReg: true });
	}

	getCountryName = (name='') => {
		if(name==='USA'){
			return 'United States';
		} else if(name==='UK'){
			return 'United Kingdom'
		} else{
			return name;
		}
	}

	render(){
		const { user, agreement, year, approvals, isDoneReg } = this.state;
		const { isEmbed, isOpen } = this.props;
		return(
			<div className="log-reg-holder" style={{ width: "100%" }}>
				<div className="split-input" style={{ width: "100%" }}>
					<div className="input-field" style={{height:'auto',marginBottom:'10px'}}>
						<span>First Name</span>
						<input value={this.state.user.name} className={(this.state.nameErr) ? "normal-input error" : "normal-input"} onChange={(e) => {
							const val = e.target.value
							this.state.user.name = val;
							this.setState({ user: this.state.user, nameErr: false });
						}}  style={{ width: "100%" }}/>
					</div>
					<div className="input-field" style={{height:'auto',marginBottom:'10px'}}>
						<span>Last Name</span>
						<input type="" value={this.state.user.surname} className={(this.state.surnameErr) ? "normal-input error" : "normal-input"} onChange={(e) => {
							const val = e.target.value
							this.state.user.surname = val;
							this.setState({ user: this.state.user, surnameErr: false });
						}}  style={{ width: "100%" }}/>
					</div>
				</div>
				<div className="split-input">
					<div className="input-field" style={{height:'auto',marginBottom:'10px'}}>
						<span>Username</span>
						<input value={this.state.user.displayName} className={(this.state.usernameError) ? "normal-input error" : "normal-input"} onChange={(e) => {
							const val = e.target.value
							this.state.user.displayName = val.toLowerCase();
							this.setState({ user: this.state.user, usernameError: (val.indexOf(" ") > -1) });
						}}  style={{ width: "100%" }}/>
					</div>
					<div className="input-field" style={{height:'auto',marginBottom:'10px'}}>
						<span>Email</span>
						<input value={this.state.user.email} type="email" className={(this.state.emailErr) ? "normal-input error" : "normal-input"} onChange={(e) => {
							const val = e.target.value
							let err = (val.indexOf('@') > -1 && val.indexOf('.') > -1) ? false : true
							this.state.user.email = val;
							this.setState({ user: this.state.user, emailErr: err });
						}}  style={{ width: "100%" }}/>
					</div>
				</div>
				{this.state.user.provider === "Supotsu" &&
					<div className="split-input">
						<div className="input-field" style={{height:'auto',marginBottom:'10px'}}>
							<span>Password</span>
							<input type="password" value={this.state.user.pass} className={(this.state.passErr) ? "normal-input error" : "normal-input"} onChange={(e) => {
								const val = e.target.value
								this.state.user.pass = val;
								let err = (val.length < 7) ? true : false
								this.setState({ user: this.state.user, passErr: err });
							}}  style={{ width: "100%" }}/>
						</div>
						<div className="input-field" style={{height:'auto',marginBottom:'10px'}}>
							<span>Repeat Password</span>
							<input type="password" value={this.state.user.confirmPass} className={(this.state.passTooErr) ? "normal-input error" : "normal-input"} onChange={(e) => {
								const val = e.target.value
								this.state.user.confirmPass = val;
								let err = (this.state.user.pass !== val) ? true : false
								this.setState({ user: this.state.user, passTooErr: err });
							}}  style={{ width: "100%" }}/>
						</div>
					</div>
				}
				<div className={(this.state.bDayErr) ? "input-field error" : "input-field"} style={{height:'auto',marginBottom:'10px'}}>
					<span>Birth Date</span>
					<DatePicker blankInit={true} withYear={true} year={year} withMonth={true} withDay={true} onChangeDate={(d) => {
						const _that = this;
						_that.state.user.bday = d;
						const arr = new Date(d).getFullYear();
						const date = new Date().getFullYear();
						if (arr < date) {
							AsyncStorage.setItem('user-year', arr).then(() => { }).catch(() => { })
						}
						const age = year ? date - year : date - arr;
						const isTrue = age <= 13 ? true : false;
						_that.state.user.isUnderAge = isTrue;
						_that.state.user.age = age;
						_that.state.user.parent = isTrue ? _that.state.user.parent : null;
						_that.state.user.coach = isTrue ? _that.state.user.coach : null;

						_that.setState({ user: _that.state.user, bDayErr: false });
					}} />
				</div>
				{user.isUnderAge && !user.isParent &&
					<div style={{ padding: "10px 10px", textAlign: "center", background: "#fff", color: "#000", marginBottom: "15px" }}>
						The minimum age limit for users of Supotsu site and app is 8 years of age. You have told us that you are {this.state.user.age} years of age, and as such you need the permission of a parent or legal guardian to make your profile live, please fill in their details below.
              		</div>
				}
				{user.isUnderAge && !user.isParent &&
					<div className={(this.state.user.parent && !this.state.user.parent.id) || (this.state.user.parent && this.state.user.parent.id) ? "split-input" : "input-field"}>
						<InputFieldUserPicker error={user.isUnderAge && user.parent === null ? true : user.parent === user.coach ? true : false} label={"Parent/Guardian Email"} onSelectedItem={(item, isEmail = false) => {
							this.state.user.parent = item;
							this.setState({ user });
						}} />
						{this.state.user.parent && !this.state.user.parent.id &&
							<InputField label={"Parent/Guardian  Name"}>
								<input className={(user.isUnderAge && user.parent === null ? true : user.parent === user.coach) ? "normal-input error" : "normal-input"} value={user.parent.name} onChange={(e) => {
									const { value } = e.target;
									user.parent.name = value;
									this.setState({ user });
								}} />
							</InputField>
						}
						{this.state.user.parent && this.state.user.parent.id &&
							<InputField label={"Parent/Guardian  Name"}>
								<input className={(user.isUnderAge && user.parent === null ? true : user.parent === user.coach) ? "normal-input error" : "normal-input"} value={user.parent.name} disabled={true} />
							</InputField>
						}
					</div>
				}
				<div className="split-input" style={{ marginTop: "10px" }}>
					<div onClick={() => {
						this.state.user.gender = "female"
						this.setState({
							user: this.state.user
						});
					}}><input className={(this.state.genErr) ? "error" : ""} type="radio" readOnly name="gender" checked={(this.state.user.gender === "female") ? true : false} /><label style={{ color: "#fff" }}>Female</label></div>
					<div onClick={() => {
						this.state.user.gender = "male"
						this.setState({
							user: this.state.user
						});
					}}><input className={(this.state.genErr) ? "error" : ""} type="radio" readOnly name="gender" checked={(this.state.user.gender === "male") ? true : false} /><label style={{ color: "#fff" }}>Male</label></div>
				</div>
				<div className="input-field" style={{ marginTop: "10px", height: 'auto' }}>
					<span>Your Location</span>
					<Geosuggest initialValue={this.state.user.location} className={this.state.locErr?"error":""} ref={(ref) => this.placeElem = ref} highlightMatch={true} onSuggestSelect={(item) => {
						const val = item.label;
						console.log(item)
						this.state.user.location = val;
						const _s = val.split(", ");
						this.state.user.country = this.getCountryName(_s[_s.length - 1]);
						this.setState({ user: this.state.user, locErr: false });
						if (this.placeElem != null) {
							this.placeElem.blur()
						}
					}} />
				</div>
				<div className="or-split">Terms and Agreement</div>
				<div style={{ padding: "10px 10px", textAlign: "center", background: "rgba(255, 255, 255,0.9)", color: "#000", marginBottom: "10px" }}>
					Before you create your account, you need agree to our <a href="somepage.xyz">Terms & Conditions</a> and/or <a href="somepage.xyz">Terms of Privacy.</a>
				</div>
				<div className="split-input" style={{ margin: "15px 0px" }}>
					<div onClick={() => {
						agreement.terms.agreed = !agreement.terms.agreed;
						agreement.terms.error = agreement.terms.agreed ? false : true;
						this.setState({
							agreement
						});
					}}><input className={(agreement.terms.error) ? "error" : ""} type="radio" readOnly name="terms" checked={agreement.terms.agreed} /><label style={{ color: "#fff" }}><a style={{ color: "#fff" }}>T&C agreement</a></label></div>
					{this.is &&<div onClick={() => {
						agreement.privacy.agreed = !agreement.privacy.agreed;
						agreement.privacy.error = agreement.privacy.agreed ? false : true;
						this.setState({
							agreement
						});
					}}><input className={(agreement.privacy.error) ? "error" : ""} type="radio" readOnly name="privacy" checked={agreement.privacy.agreed} /><label style={{ color: "#fff" }}><a href={""} style={{ color: "#fff" }}>Terms of Privacy</a></label></div>}
				</div>
				{<button className="gbl-btn" onClick={() => this.saveGeneric()}>Register</button>}
				{<div className="or-split">Sign up with your social account</div>}
				<div style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-evenly'
				}}>
					{<SocialButton pref="Sign up with " mini={true} label="Facebook" src="images/facebook_icon_wht.svg" onClick={() => { this.signWithFacebook() }} />}
					{<SocialButton pref="Sign up with " mini={true} label="Twitter" src="images/twitter_icon_wht.svg" onClick={() => { this.signWithTwitter() }} />}
					{<SocialButton pref="Sign up with " mini={true} label="Google" src="images/google_icon.svg" onClick={() => { this.signWithGoogle() }} />}
				</div>
				{<div className="or-split">Can also</div>}
				{<button className="gbl-btn" onClick={() => {
					window.location = "/create"
				}}>Create a Club, Team or Tournament profile</button>}
				{isDoneReg &&
					<Redirect
						to={{
							pathname: "/register",
							state: { from: this.props.location, data: this.state}
						}}
					/>
				}
			</div>
		)
	}
};

Register.Home = _HomeReg;

class InputFieldUserPicker extends Component {
	state = {
		user: { id: null, name: "", email: "" },
		isLoading: false,
		results: [],
		isFocus: false
	}

	componentDidMount() {
		this.getData();
	}

	getData = () => {
		const _that = this;
		_that.setState({ isLoading: true });
		FakeData.post("/getAllUsers.php?auth0", {}, {
			success(res) {
				if (res.status === "illegal_entry") {
					_that.setState({ results: [], isLoading: false });
					return;
				}
				_that.setState({ results: res, isLoading: false });
			}
		})
	}

	render = () => {
		const { label } = this.props;
		const { results, isLoading, user, isFocus } = this.state;
		const _res = results.filter((item, i) => { return item.email.toLowerCase().indexOf(user.email.toLowerCase()) > -1 });
		return (
			<div className="input-field" ref={"root"} style={{ position: "relative" }} tabIndex={0} onFocus={() => {
				this.setState({ isFocus: true });
			}} onBlur={() => {
				this.setState({ isFocus: false });
			}}>
				<span>{label}</span>
				<input value={this.state.user.email} placeholder={"Email"} className={(this.props.error) ? "normal-input error" : "normal-input"} onChange={(e) => {
					const val = e.target.value
					user.email = val;
					this.setState({ user });
				}} onFocus={() => {
					this.setState({ isFocus: true });
				}} />
				{isFocus &&
					<div className="input-field-dp">
						<EmptyState isShown={isLoading} text={"Loading..."} style={{ padding: "10px 0px", height: "50px" }} />
						{!isLoading &&
							results.filter((item, i) => { return item.email.toLowerCase().indexOf(user.email.toLowerCase()) > -1 }).map((item, i) => {
								if (item.id === user.id) {
									return null;
								} else {
									return (
										<div key={i} className="input-field-dp-item" onClick={() => {
											this.setState({ user: item, isFocus: false });
											this.refs.root.blur();
											if (this.props.onSelectedItem) {
												this.props.onSelectedItem(item)
											}
										}}>
											<img src={item.image} />
											<span>{item.name}</span>
										</div>
									)
								}
							})
						}
						{!isLoading && _res.length === 0 &&
							<div className="input-field-dp-item" onClick={() => {
								const _user = {
									id: false,
									email: user.email,
									name: ""
								}
								if (FakeData.isEmail(user.email)) {
									this.setState({ user: _user, isFocus: false });
									this.refs.root.blur();
									if (this.props.onSelectedItem) {
										this.props.onSelectedItem(_user, true)
									}
								} else {
									alert('Invalid email address')
								}
							}}>
								<img src={FakeData.apiURL+"/default_avatar.svg"} />
								<span>{user.email}</span>
							</div>
						}
					</div>
				}
			</div>
		)
	}
}

class ParentApproveModal extends Component {
	constructor(props) {
		super(props)
		this.state = {
			approvals:FakeData.listify(this.props.approvals)
		}
	}

	render() {
		if(this.state.approvals.length === 0){
			return null;
		}
		return (
			<Modal isOpen={true} onClose={false}>
				<div className="add-place" style={{
					width: '50vw',
					minHeight: '50vh'
				}}>
					<h1>If you know any of the following people, they're are waiting for you to approve their account.</h1>
					<p>
						<span><strong>Why this?</strong></span><br/>
						<span>When these people registered their account, they listed your email address as one of their parents, if this is true - approve them or report to us.</span>
					</p>
					<div>
						{
							this.state.approvals.map((item, i)=>{
								return(
									<ParentApproveItem key={item.id} item={item} onApprove={()=>{
										const approvals = this.state.approvals.filter((_item, _i)=>{
											return _item.id !== item.id;
										});
										this.setState({ approvals });
									}}/>
								)
							})
						}
					</div>
				</div>
			</Modal>
		)
	}
}

class ParentApproveItem extends Component{
	constructor(props) {
		super(props)
		this.state = {
			isLoading: false,
			isDone: false
		}
	}

	approve = () => {
		const { isLoading,isDone } = this.state;
		const {item, onApprove} = this.props;
		const _that = this;
		const data = {
			id: item.id,
			user_id: this.props.user.id
		}

		const _cb = () => {
			setTimeout(()=>{
				if(onApprove){
					onApprove()
				}
			}, 1000)
		}

		FakeData.post("/verifyChild.php?auth0", data, {
			success(res) {
				_that.setState({
					isLoading: false,
					isDone: !res.error
				});
				if(!res.error){
					_cb();
				}
			},
			error(e) {
				_that.setState({
					isLoading: false,
					isDone: false
				});
			}
		})
	}

	render(){
		const {item, onApprove} = this.props;
		const {isLoading, isDone} = this.state;
		return(
			<View style={{
				flexDirection:'row',
				paddingHorizontal: 10,
				paddingVertical: 10,
				alignItems: 'center',
				borderBottomWidth: 1,
				borderBottomColor: '#ddd'
			}}>
				<img style={{
					width: "40px",
					height: "40px",
					marginRight: 10,
					borderRadius: 100
				}} src={item.user.image}/>
				<span style={{
					flex:1
				}}>{item.user.name}</span>
				{!isLoading &&
					<TouchableOpacity style={{
						paddingHorizontal: 10,
						paddingVertical: 5,
						backgroundColor: '#4ac'
					}} activeOpacity={0.8} onPress={()=>{
						this.setState({ isLoading: true });
						this.approve()
					}}><span style={{color:'#fff'}}>Approve</span></TouchableOpacity>
				}
				{!isLoading &&
					<TouchableOpacity style={{
						paddingHorizontal: 10,
						paddingVertical: 5,
						backgroundColor: '#345'
					}} activeOpacity={0.8} onPress={()=>{
						
					}}>
					<FeedBackPopUp key={"profile-" + item.user.id} isBanner={true} userTo={{
						id: FakeData.getData("yoo").id,
						type: "F"
					}} noIcon={true} user={{
						id: item.user.id,
						type: "F"
					}} object={{
						id: item.user.id,
						type: "F",
						content: item.user.name,
						image: item.user.image
					}} owner={{
						id: item.user.id,
						type: "F",
						name: item.user.name,
						user: item.user.username,
						image: item.user.image,
						email: item.user.email
					}} text={"Report"} iconStyle={{
						margin: "0px 0px 0px 10px",
					}} icon={"more_horiz"} style={{
						display: 'flex',
						color:"#fff"
					}} menus={{
							FeedBack: { label: "Report Profile", cb: () => {
								if(onApprove){
									onApprove();
								}
							 } }
						}} />
					</TouchableOpacity>
				}
				{isLoading && !isDone &&
					<ActivityIndicator color="#4ac"/>
				}
				{isDone &&
					<Ionicon icon="md-done-all" color="#4ac" fontSize="25px" style={{
						width: "25px",
						height: "25px"
					}}/>
				}
			</View>
		)
	}
}

class SocialButton extends Component {
	constructor(props) {
		super(props)
	}

	render() {
		if(this.props.mini){
			return(
				<a className={"btn_" + this.props.label.toLowerCase()} onClick={() => this.props.onClick()} style={{
					display: 'inline-block'
				}}>
				</a>
			)
		}
		return (
			<div className={"social-btn " + this.props.label.toLowerCase()} onClick={() => this.props.onClick()}>
				<img src={this.props.src} />
				<span>{this.props.pref + this.props.label}</span>
			</div>
		);
	}
}

export class AddSportFollow extends Component {
	constructor(props) {
		super(props)
		this.state = {
			sports: [],
			list: []
		}
	}

	componentDidMount() {
		FakeData.mountState("sport-fl-picker", true)
		this.getSports()
	}

	componentWillUnmount() {
		FakeData.mountState("sport-fl-picker", false)
	}


	onClose() {
		const arr = []
		const sports = this.state.sports
		const _that = this
		//console.log(data)
		sports.forEach((item, i) => {
			if (item.isSelected) {
				arr.push(item)
			}
		})

		this.props.onClose(arr)
	}

	getSports() {
		if (this.state.sports.length > 0 || !FakeData.isMounted("sport-fl-picker")) {
			return;
		}

		const _that = this

		this.setState({
			sports: (FakeData.getData("all_sports")) ? FakeData.getData("all_sports") : [],
			list: (FakeData.getData("all_sports")) ? FakeData.getData("all_sports") : []
		});

		setTimeout((() => {
			_that.getSports()
		}), 1500)
	}

	filterSports(val) {
		const sports = this.state.sports
		const _that = this
		const list = []
		sports.forEach((item, i) => {
			if (item.name.toLowerCase().indexOf(val.toLowerCase()) > -1) {
				list.push(item)
				this.setState({
					list: list
				});
			}
		})
	}

	onSelectSport(data) {
		const sports = this.state.sports
		const _that = this
		//console.log(data)
		sports.forEach((item, i) => {
			if (item.name === data.name) {
				item.isSelected = (item.isSelected) ? false : true
				this.setState({
					sports: this.state.sports
				});
			}
		})
	}

	addhere() {
		const url = "/saveToSports.php?auth0";
		const arr = []
		const sports = this.state.sports
		const _that = this
		const already = []
		//console.log(data)
		sports.forEach((item, i) => {
			if (item.isSelected && !this.notInMine(item)) {
				arr.push(item)
			}

			if (item.isSelected && this.notInMine(item)) {
				already.push(item)
			}
		})

		const dataTo = {
			userId: this.props.to,
			sportsFollowed: arr
		}

		FakeData.post(url, dataTo, {
			success: ((res) => {
				_that.onClose()
			}),
			error: ((err) => {

			})
		}, true, (already.length > 0) ? already.length + " Sports were not added because you already follow them" : "Data Saved!", ((e) => { }))

		this.props.onClose(arr)
	}

	addToClub() {
		const url = "/saveClubSports.php?auth0";
		const arr = []
		const sports = this.state.sports
		const _that = this
		const already = []
		//console.log(data)
		sports.forEach((item, i) => {
			if (item.isSelected && !this.notInMine(item)) {
				arr.push(item)
			}

			if (item.isSelected && this.notInMine(item)) {
				already.push(item)
			}
		})

		const dataTo = {
			id: this.props.to,
			type: this.props.type,
			sports: arr
		}

		FakeData.post(url, dataTo, {
			success: ((res) => {
				_that.onClose()
			}),
			error: ((err) => {

			})
		}, true, (already.length > 0) ? already.length + " Sports were not added because you already have in your club" : "Data Saved!", ((e) => { }))

		this.props.onClose(arr)
	}

	notInMine(sport) {
		const arr = this.props.sports;
		let bool = false;
		for (let x = 0; x < arr.length; x++) {
			if (arr[x].id === sport.id) {
				bool = true;
				break;
			}
		}

		return bool;
	}

	render() {
		const sports = (FakeData.getData("all_sports")) ? FakeData.getData("all_sports") : []
		return (
			<Modal isOpen={this.props.isOpen} onClose={this.onClose.bind(this)}>
				<div className="sport-picker add-place" style={{ width: "640px" }}>
					<h1>Add A Sport</h1>
					<input list="sports" placeholder="Search for sport" style={{ padding: "3px", width: "100%", marginBottom: "5px" }} onChange={(e) => {
						const val = e.target.value
						this.filterSports(val)
					}} />
					<datalist id="sports">
						{
							this.state.sports.map((item, i) => {
								return (
									<option key={i} value={item.name} />
								)
							})
						}
					</datalist>
					<div className="sport-pk-list">
						{
							this.state.sports.map((item, i) => {
								if (!item.isSelected) {
									return null;
								}

								return (
									<div key={i} onClick={() => this.onSelectSport(item)} className={(item.isSelected) ? "active" : ""}>
										<img src={(item.image !== null) ? item.image.replace("_wht", "") : "server/media/blank_emblem.png"} />
									</div>
								)
							})
						}
						{
							this.state.list.map((item, i) => {
								if (item.isSelected) {
									return null;
								}

								return (
									<div key={i} onClick={() => this.onSelectSport(item)} className={(item.isSelected) ? "active" : ""}>
										<img src={(item.image !== null) ? item.image.replace("_wht", "") : "server/media/blank_emblem.png"} />
									</div>
								)
							})
						}
					</div>
					<button className="gbl-btn" onClick={() => {
						if (this.props.isExtending) {
							this.addhere()
						} else if (this.props.isClub) {
							this.addToClub()
						} else {
							this.onClose()
						}
					}}>Add Sports</button>
				</div>
			</Modal>
		);
	}
}

export class AddSportPlay extends Component {
	constructor(props) {
		super(props)
		this.state = {
			sports: [],
			teams: [],
			sport: {},
			sportFilter: "",
			teamFilter: "",
			team: {},
			position: "",
			location: "",
			coords: {}
		}
	}

	onClose() {
		this.props.onClose(null)
	}

	onSelectSport(value) {
		this.setState({
			sportFilter: value,
			team: {},
			sportErr: false
		});
	}

	getTeams(arr) {
		const list = [];
		arr.forEach((item, i) => {
			if (((item.sport !== null) && item.sport.toLowerCase().indexOf(this.state.sportFilter.toLowerCase()) > -1) && item.name.toLowerCase().indexOf(this.state.teamFilter.toLowerCase()) > -1 && item.location.toLowerCase().indexOf(this.state.location.toLowerCase()) > -1) {
				list.push(item)
			}
		})

		return list;
	}

	onAddSport() {
		if (this.state.sportFilter === "") {
			this.setState({
				sportErr: true
			});

			return
		}

		if (this.state.position === "") {
			this.setState({
				posErr: true
			});

			return
		}

		if (!this.state.team.id) {
			this.setState({
				teamErr: true
			});

			return
		}

		const sports = (FakeData.getData("all_sports")) ? FakeData.getData("all_sports") : []
		sports.forEach((item, i) => {
			if (item.name === this.state.sportFilter) {
				const dataTo = item
				dataTo.position = this.state.position;
				dataTo.team = this.state.team

				this.props.onClose(dataTo)
				this.setState({
					sports: [],
					teams: [],
					sport: {},
					sportFilter: "",
					teamFilter: "",
					team: {},
					position: ""
				});
			}
		})
	}

	addhere() {
		const url = "/saveToSports.php?auth0";
		const _that = this
		//console.log(data)
		if (this.state.sportFilter === "") {
			this.setState({
				sportErr: true
			});

			return
		}

		if (this.state.position === "") {
			this.setState({
				posErr: true
			});

			return
		}

		if (!this.state.team.id) {
			this.setState({
				teamErr: true
			});

			return
		}

		const sports = (FakeData.getData("all_sports")) ? FakeData.getData("all_sports") : []
		let bool = false;
		let dataTo = {}
		for (let x = 0; x < sports.length; x++) {
			const item = sports[x];
			if (item.name === this.state.sportFilter && !this.notInMine(item)) {
				dataTo = item
				dataTo.position = this.state.position;
				dataTo.team = this.state.team
				bool = true;
				break;
			}
		}

		if (!bool) {
			alert("Sport item already exist!");
			_that.setState({
				sports: [],
				teams: [],
				sport: {},
				sportFilter: "",
				teamFilter: "",
				team: {},
				position: ""
			});
		} else {
			const arr = []
			arr[0] = dataTo
			const _dataTo = {
				id: _that.props.to,
				sportsPlayed: arr
			}

			FakeData.post("/saveSportPlay.php?auth0", _dataTo, {
				success: ((e) => {
					_that.props.onClose(dataTo)
					_that.setState({
						sports: [],
						teams: [],
						sport: {},
						sportFilter: "",
						teamFilter: "",
						team: {},
						position: ""
					});
				}),
				error: ((e) => {

				})
			}, true, "Data SaveD!", ((e) => { }))
		}
	}

	notInMine(sport) {
		const arr = this.props.sports;
		let bool = false;
		for (let x = 0; x < arr.length; x++) {
			if (arr[x].id === sport.id) {
				bool = true;
				break;
			}
		}

		return bool;
	}

	render() {
		const sports = (FakeData.getData("all_sports")) ? FakeData.getData("all_sports") : []
		const teams = this.getTeams((FakeData.getData("all_teams")) ? FakeData.getData("all_teams") : [])
		return (
			<Modal isOpen={this.props.isOpen} onClose={this.onClose.bind(this)}>
				<div className="sport-picker add-place" style={{ width: "640px" }}>
					<h1>Add A Sport</h1>

					{/*<select className={(this.state.sportErr)?"error":""} onChange={(e)=>{
              this.onSelectSport(e.target.value)
            }}>
            <option disabled="true">Select Sport</option>
            {
              sports.map((item,i)=>{
                return(
                  <option key={i} value={item.name}>{item.name}</option>
                )
              })
            }
          </select>*/}
					<div className="split-input">
						<div>

							<input list="sports" className={(this.state.sportErr) ? "error" : ""} placeholder="Search for sport" style={{ padding: "3px", width: "100%", marginBottom: "5px" }} onChange={(e) => {
								this.onSelectSport(e.target.value)
							}} />
							<datalist id="sports">
								{
									sports.map((item, i) => {
										return (
											<option key={i} value={item.name} />
										)
									})
								}
							</datalist>
							<input placeholder="Search Team by Name" style={{ padding: "3px", width: "100%", marginBottom: "5px" }} onChange={(e) => {
								this.setState({
									teamFilter: e.target.value
								});
							}} />
						</div>
						<div>
							<input placeholder="Position you play" className={(this.state.posErr) ? "error" : ""} style={{ padding: "3px", width: "100%", marginBottom: "5px" }} onChange={(e) => {
								this.setState({
									position: e.target.value,
									posErr: false
								});
							}} />
							<Geosuggest placeholder="Search by Suburbs, Street, City or Country" ref={(ref) => this.placeElem = ref} highlightMatch={true} onSuggestSelect={(item) => {
								const val = item.label
								this.setState({ location: val, coords: item.location });
								if (this.placeElem != null) {
									this.placeElem.blur()
								}
							}} onChange={(item) => this.setState({ location: item })} />
						</div>
					</div>

					<div className={(this.state.teamErr) ? "sport-pk-list error" : "sport-pk-list"}>
						{
							teams.map((item, i) => {
								if (item.image === null) {
									return null;
								}

								return (
									<div key={i} onClick={() => this.setState({
										team: item,
										teamErr: false
									})} className={(item.id === this.state.team.id) ? "active" : ""}>
										<img src={item.image} />
									</div>
								)
							})
						}
					</div>

					<button className="gbl-btn" onClick={() => {
						if (this.props.isExtending) {
							this.addhere()
						} else {
							this.onAddSport()
						}
					}}>Add Sport</button>
				</div>
			</Modal>
		);
	}
}

class EncryptedPages extends React.PureComponent {
	constructor(p) {
		super(p)
		this.state = {

		}
	}

	componentDidMount() {
		this._isMounted = true;
		if (fakeAuth.isAuthenticated) {
			const { pageType } = this.props;
			const from = parseURL(document.referrer);
			const to = parseURL(window.location.href)
			this.runInit(2000)
		}
	}


	componentWillUnmount() {
		this._isMounted = false;
		if (fakeAuth.isAuthenticated) {
			const { pageType } = this.props;
		}
	}

	runInit = (int = 1000) => {
		const _that = this;
		const from = parseURL(document.referrer);
		const to = parseURL(window.location.href);
		const user = {
			id: FakeData.getData("yoo").id,
			type: "F"
		}

		const data = {
			user,
			from,
			to
		}

		/*FakeData.post("/", data, {
		  success(res){
			_that.id = "";
			setTimeout(()=>{
			  _that.update(2000)
			}, int)
		  },
		  error(){
	
		  }
		})*/
	}

	update = (int = 1000) => {
		const _that = this;
		const data = {
			id: this.id
		}

		FakeData.post("/", data, {
			success(res) {
				_that.id = "";
				setTimeout(() => {
					_that.update(int)
				}, int)
			},
			error() {

			}
		})
	}

	render() {
		const withGuest = this.props.withGuest;

		if (!fakeAuth.isAuthenticated && withGuest) {
			const $Component = this.props.component;
			return (
				<Scaffold isDashboard={this.props.pageType === "DASH" ? true : false} key={this.props.pageType} fakeAuth={fakeAuth} onLogout={fakeAuth.signout}  {...this.props}>
					<$Component fakeAuth={fakeAuth} onLogout={fakeAuth.signout} match={this.props.match} user={FakeData.guest} withGuest={true} history={this.props.history} location={this.props.location} />
				</Scaffold>
			)
		}

		if (fakeAuth.isAuthenticated) {
			const $Component = this.props.component;
			const withGuest = this.props.withGuest
			return (
				<Scaffold isDashboard={this.props.pageType === "DASH" ? true : false} fakeAuth={fakeAuth} onLogout={fakeAuth.signout}  {...this.props}>
					<$Component fakeAuth={fakeAuth} onLogout={fakeAuth.signout} match={this.props.match} user={FakeData.getData("yoo")} withGuest={false} history={this.props.history} location={this.props.location} />
				</Scaffold>
			)
		}

		return (
			<Redirect to={{
				pathname: this.props.pageType==='create'?`/login?ref=${this.props.location.pathname}`:_pageName,
				state: { from: this.props.location }
			}} />
		);
	}
}

class Scaffold extends Component {
	constructor(p) {
		super(p)
		this.state = {
			user: {},
			isShowingBodyOnly: false,
			openChats: [],
			lang: "en",
			isBlocked: false,
			BlockedByYou: [],
			BlockedBySystem: [],
			BlockedForYou: []
		}

		this.ToggleBody = this.ToggleBody.bind(this);
		this.onSizeChange = this.onSizeChange.bind(this)
	}

	componentWillMount() {
		if (this.props.isDashboard) {
			FakeData.setData("isDashboard", true)
		} else {
			FakeData.setData("isDashboard", false)
		}
	}

	componentDidMount() {
		this._isMounted = true;
		const { openChats, user, isShowingBodyOnly } = this.state;
		const _that = this;
		FakeData.shared("Scaffold", this);
		window.SPToggleBody = this.ToggleBody;
		try {
			this.io = new window.io.connect(FakeData.apiURL+"/wsApp", { transports: ['polling', 'websocket'] });
			let _user = FakeData.getData("yoo");
			delete _user.settings;
			delete _user.hash_key;
			this.io.on("io_connected", (data) => {
				_that.io.emit("set_online", {
					device: "WEB",
					userData: _user
				});

				_that.io.emit("blocked_system", {
					id: "0",
					type: "F"
				});

				_that.io.emit("blocked_by_you", {
					id: _user.id,
					type: "F"
				});

				_that.io.emit("blocked_for_you", {
					id: _user.id,
					type: "F"
				});
			});

			this.io.on("blocked_system", data => {
				FakeData.setData("BlockedBySystem", data, () => {
					_that.setState({ BlockedBySystem: data });
					setTimeout(() => {
						if (_that._isMounted && _that.io) {
							_that.io.emit("blocked_system", {
								id: "0",
								type: "F"
							})
						}
					}, 3000)
				})
			})

			this.io.on("blocked_by_you", data => {
				FakeData.setData("BlockedByYou", data, () => {
					_that.setState({ BlockedByYou: data });
					setTimeout(() => {
						if (_that._isMounted && _that.io) {
							_that.io.emit("blocked_by_you", {
								id: _user.id,
								type: "F"
							})
						}
					}, 3000)
				})
			})

			this.io.on("blocked_for_you", data => {
				FakeData.setData("BlockedForYou", data, () => {
					_that.setState({ BlockedForYou: data });
					setTimeout(() => {
						if (_that._isMounted && _that.io) {
							_that.io.emit("blocked_for_you", {
								id: _user.id,
								type: "F"
							})
						}
					}, 3000)
				})
			})

			this.io.on("notification", (_data) => {
				const { data, type } = _data;
				switch (type) {
					case 'notification':
						break;
					case 'message':
						break;
					default:
						break;
				}
			})

			FakeData.io = this.io;

			this.io.on("kill", (data) => {
				_that.io = false;
				FakeData.io = false;
			})
		} catch (error) {
			FakeData.io = false
		}

		FakeData.App.globals.io = this.io;
		this.setChatSocket();
	}

	setBlocked = (bool = false, cb = () => { }) => {
		this.setState({
			isBlocked: bool
		}, cb);
	}

	setChatSocket = () => {
		const _that = this;

		try {
			this.chat = new window.io.connect(FakeData.apiURL+"/wsChats", { transports: ['polling', 'websocket'] });
			let _user = FakeData.getData("yoo");
			delete _user.settings;
			delete _user.hash_key;
			this.chat.on("chat_open", (data) => {
				FakeData.chatIO = _that;
			})
		} catch (error) {
			FakeData.chatIO = false;
		}
	}

	ToggleBody = (cb = false) => {
		const { openChats, user, isShowingBodyOnly } = this.state;
		this.setState({
			isShowingBodyOnly: !isShowingBodyOnly
		});

		if (cb) {
			cb();
		}
	}

	componentWillUnmount() {
		this._isMounted = false;
		window.SPToggleBody = false;
		FakeData.io = false;
		FakeData.App.globals.io = false;
		FakeData.shared("Scaffold", false);
	}

	onSizeChange = (event) => {
		const _width = event.target.innerWidth;
		if (_width <= 1024) {
			const _url = "m." + window.location.host + window.location.pathname;
			window.location = _url;
		}
	}

	render = () => {
		const { children, hideExtra, isDashboard } = this.props;
		const { openChats, user, isShowingBodyOnly, lang, isBlocked, BlockedBySystem, BlockedByYou, BlockedForYou } = this.state;
		const childrenWithProps = React.Children.map(children, child =>
			React.cloneElement(child, { BlockedBySystem, BlockedByYou, BlockedForYou, io: this.io, isBlocked }));

		return (
			<IntlProvider locale={lang}>
				<div className="app">
					{!isShowingBodyOnly && !hideExtra && !isBlocked && <HeaderUI homePath={_homeName} isLogged={fakeAuth.isAuthenticated} fakeAuth={fakeAuth} onLogout={fakeAuth.signout} />}
					{!isBlocked && !isDashboard &&
						<div className="container" style={{ paddingPottom: '2cm', minHeight: "600px" }}>
							{childrenWithProps}
						</div>
					}

					{(!isBlocked || isBlocked) && isDashboard &&
						<div className="container" style={{ paddingPottom: '2cm', minHeight: "600px" }}>
							{childrenWithProps}
						</div>
					}

					{isBlocked &&
						<HeaderShimmer />
					}

					{isBlocked && !isDashboard &&
						<div className="container" style={{ paddingPottom: '2cm', minHeight: "600px" }}>
							<BannerShimmer />
						</div>
					}

					{!isShowingBodyOnly && !hideExtra && !isBlocked && <ChatBoxList chats={openChats} />}
					{!isShowingBodyOnly && !hideExtra && !isBlocked && <FooterUI />}
				</div>
			</IntlProvider>
		);
	}
}

function parseURL(url) {
	var a = document.createElement('a');
	a.href = url;
	return {
		source: url,
		protocol: a.protocol.replace(':', ''),
		host: a.host,
		hostname: a.hostname,
		port: a.port,
		query: a.search,
		params: FakeData.getQueries(a.search),
		hash: a.hash.replace('#', ''),
		path: a.pathname.replace(/^([^/])/, '/$1')
	};
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js